import {
  Add,
  AddOutlined,
  ArrowDropDown,
  Clear,
  ClearAll,
  Close,
  CloseOutlined,
  Delete,
  DeleteOutline,
  Description,
  DescriptionOutlined,
  DriveFileMove,
  Edit,
  FileCopyOutlined,
  FileDownloadOutlined,
  FileUploadOutlined,
  Filter,
  Filter1,
  Filter1Outlined,
  Filter2Sharp,
  FilterAlt,
  FilterAltOffOutlined,
  FilterAltOutlined,
  FilterList,
  FilterListOff,
  FilterOutlined,
  Folder,
  FolderOutlined,
  FolderSpecialOutlined,
  GridView,
  KeyboardArrowDown,
  Label,
  LabelOutlined,
  ListAlt,
  More,
  MoreHoriz,
  MoreVert,
  NavigateNext,
  Pages,
  PagesOutlined,
  PlayArrow,
  Search,
  SettingsOutlined,
  TrackChanges,
} from "@mui/icons-material";
import {
  Avatar,
  Badge,
  Box,
  Breadcrumbs,
  Button,
  Chip,
  CircularProgress,
  debounce,
  Divider,
  Fab,
  FormControl,
  Icon,
  IconButton,
  InputAdornment,
  InputLabel,
  List,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Popover,
  Select,
  Skeleton,
  styled,
  Tab,
  Tabs,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  toggleButtonGroupClasses,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { ArrowBackOutlined } from "@mui/icons-material";
import LabelButton from "../../common/LabelButton";

import { font } from "../../../styles/font";
import { getThemeColors } from "../../../styles/theme";
import { useEffect, useState, lazy, Suspense } from "react";
import { useApplicationContext } from "../../../context/ApplicationContext";
import useErrorHandler from "../../../api/errorHandler/useErrorHandler";
import { HttpStatusCode } from "axios";

import qs from "qs";
import {
  Dashboard_Entity,
  Entity,
  Entity_Label,
  FolderType,
  ModulePath,
  Severity,
  StoryStatus,
} from "../../../constant/ApplicationVariables";
import {
  addStory_API,
  deleteStory_API,
  getStoryList_API,
  getStoryListAll_API,
  getStoryPropertiesList_API,
  updateStory_API,
} from "../../../api/controller/StoryController";
import FolderSpecialIcon from "@mui/icons-material/FolderSpecialOutlined";
import GridViewTwoToneIcon from "@mui/icons-material/GridViewTwoTone";
import ListTwoToneIcon from "@mui/icons-material/ListTwoTone";
import { useLocation, useSearchParams } from "react-router-dom";
import {
  addUseCase_API,
  deleteUseCase_API,
  getUseCaseList_API,
  getUseCaseListAll_API,
  getUseCasePropertiesList_API,
  updateUseCase_API,
} from "../../../api/controller/UseCaseController";
import dayjs from "dayjs";
import {
  getTestCaseList_API,
  getTestCaseListAll_API,
  getTestCasePropertiesList_API,
  updateTestCase_API,
  deleteTestCase_API,
} from "../../../api/controller/TestCaseController";
import { moveFolder_API } from "../../../api/controller/ModuleController";
import {
  DashboardCustomIcon,
  FolderCustomIcon,
  FolderIcon,
  PageCustomIcon,
  ProjectCustomIcon,
  ProjectIcon,
  TestCaseCustomIcon,
  TestCaseIcon,
  UseCaseCustomIcon,
  UseCaseIcon,
  UserStoryCustomIcon,
  UserStoryIcon,
} from "../../styled/CustomIcons";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { useHotkeys } from "react-hotkeys-hook";
import { KeyboardKeys } from "../../../constant/KeyboardKeys";
import { useTranslation } from "react-i18next";
import { LightTooltip } from "../../styled/CustomComponent";
import FallbackUILoader from "../../loader/FallbackUILoader";
import { useCallback } from "react";
import TaskContainer from "../../tasks";
import RegressionContainer from "../../regression/pages/RegressionSuites";
import { formatDate } from "../../../utils/DateTime";
import { getDashboardReportList_API } from "../../../api/controller/DashboardController";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  ACTIVE_PROJECT_TABS,
  Filters,
} from "../../../constant/ApplicationJson";
import FilterDrawerItemDrawer from "../../drawer/FilterDrawerItemDrawer";
import MarketplaceDashboard from "../../marketplace/MarketplaceDashboard";

const UserStoryGrid = lazy(() => import("../../userStory/UserStoryGrid"));
const UserStoryList = lazy(() => import("../../userStory/UserStoryList"));
const CreateStoryComponent = lazy(
  () => import("../../userStory/CreateStoryComponent"),
);
const EditStoryComponent = lazy(
  () => import("../../userStory/EditStoryComponent"),
);
const LinkTagDrawer = lazy(() => import("../../drawer/LinkTagDrawer"));
const UseCaseGrid = lazy(() => import("../../useCase/UseCaseGrid"));
const UseCaseList = lazy(() => import("../../useCase/UseCaseList"));
// Add this import
const TestCaseList = lazy(() => import("../../testCase/TestCaseList"));
const EditUseCaseComponent = lazy(
  () => import("../../useCase/EditUseCaseComponent"),
);
const CreateUseCaseComponent = lazy(
  () => import("../../useCase/CreateUseCaseComponent"),
);
const DeleteProjectItemDialog = lazy(
  () => import("../../dialog/DeleteProjectItemDialog"),
);
const FilterItemDrawer = lazy(() => import("../../drawer/FilterItemDrawer"));
const CreateTestCaseComponent = lazy(
  () => import("../../testCase/CreateTestCaseComponent"),
);
const EditTestCaseComponent = lazy(
  () => import("../../testCase/EditTestCaseComponent"),
);
const DashboardContainerComponent = lazy(() => import("../../dashboard"));
const ConfigurationContainerComponent = lazy(
  () => import("../../configuration"),
);
const PlanningContainerComponent = lazy(() => import("../../planning"));
const ExecutionContainerComponent = lazy(() => import("../../execution"));

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  [`& .${toggleButtonGroupClasses.grouped}`]: {
    margin: theme.spacing(0.5),
    border: 0,
    borderRadius: theme.shape.borderRadius,
    [`&.${toggleButtonGroupClasses.disabled}`]: {
      border: 0,
    },
  },
  [`& .${toggleButtonGroupClasses.middleButton},& .${toggleButtonGroupClasses.lastButton}`]:
    {
      marginLeft: -1,
      borderLeft: "1px solid transparent",
    },
}));

const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  padding: theme.spacing(0.5),
}));

export default function ActiveProjectContainer() {
  const {
    openCreateStoryDialog,
    setOpenCreateStoryDialog,
    openEditStoryDialog,
    setOpenEditStoryDialog,
    openDeleteStoryDialog,
    setOpenDeleteStoryDialog,
    currentFolderData,
    setCurrentFolderData,
    currentUserStoryData,
    setCurrentUserStoryData,
    userStoryList,
    setUserStoryList,
    userStoryPropertiesData,
    setUserStoryPropertiesData,
    handleSnackbar,
    selectedUserStoryList,
    setSelectedUserStoryList,
    activeProject,
    isUserStoryLoading,
    setIsUserStoryLoading,
    openLinkTagDrawer,
    setOpenLinkTagDrawer,
    isGridViewEnabled,
    setIsGridViewEnabled,
    isUpdateFolderStructure,
    setIsUpdateFolderStructure,
    openCreateUseCaseDialog,
    setOpenCreateUseCaseDialog,
    openEditUseCaseDialog,
    setOpenEditUseCaseDialog,
    openDeleteUseCaseDialog,
    setOpenDeleteUseCaseDialog,
    currentUseCaseData,
    setCurrentUseCaseData,
    useCaseList,
    setUseCaseList,
    useCasePropertiesData,
    setUseCasePropertiesData,
    selectedUseCaseList,
    setSelectedUseCaseList,
    isActiveProjectContainerLoading,
    setIsActiveProjectContainerLoading,
    isItemChatWindow,
    setIsItemChatWindow,
    openItemFilterDrawer,
    setOpenItemFilterDrawer,
    folderStructureList,
    activeDashboard,
    setActiveDashboard,
    activeDashboardModule,
    setActiveDashboardModule,
    activeConfiguration,
    setActiveConfiguration,
    handlePageDetails,
    setCurrentFilters,
    openCreateTaskDialog,
    setOpenCreateTaskDialog,
    isFolderStructureLoading,
    setIsFolderStructureLoading,
    dashboardReportList,
    setDashboardReportList,
    openEditReportDialog,
    setOpenEditReportDialog,
    currentDashboardReportData,
    setCurrentDashboardReportData,
    // Add test case states from context
    testCaseList,
    setTestCaseList,
    selectedTestCaseList,
    setSelectedTestCaseList,
    filteredTestCaseList,
    setFilteredTestCaseList,

    setSelectedReleaseIndex,
    setSelectedSprintIndex,
    dashboardFilterSelectedSprint,
    setDashboardFilterSelectedSprint,
    dashboardFilterSelectedRelease,
    setDashboardFilterSelectedRelease,
  } = useApplicationContext();
  const theme = useTheme();
  const errorHandler = useErrorHandler();
  const pathName = useLocation()?.pathname;
  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation("translation", { keyPrefix: "path" });
  const colors = getThemeColors();

  useHotkeys(KeyboardKeys.N, (e) => handleOpenCreateDialog());

  const [breadCrumbsList, setBreadCrumbsList] = useState([]);
  const [locationPathList, setLocationPathList] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [currentTab, setCurrentTab] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [tabsList, setTabsList] = useState([
    {
      label: "View List",
      value: ACTIVE_PROJECT_TABS.userStory,
      disabled: false,
    },
    { label: "View List", value: ACTIVE_PROJECT_TABS.useCase, disabled: false },
    {
      label: "Dashboard",
      value: ACTIVE_PROJECT_TABS.dashboard,
      disabled: true,
    },
  ]);

  const [range, setRange] = useState();
  const [activePlanningMode, setActivePlanningMode] =
    useState("Release Planning");

  const [selectedCalenderDate, setSelectedCalenderDate] = useState(null);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [openDashItemFilterDrawer, setOpenDashItemFilterDrawer] =
    useState(false);

  const [tempSelectedLevel, setTempSelectedLevel] = useState(selectedLevel);
  const [tempSelectedCalenderDate, setTempSelectedCalenderDate] =
    useState(selectedCalenderDate);
  const [tempDateRange, setTempDateRange] = useState(dateRange);

  const isHideLocationPath = [
    ModulePath.task,
    ModulePath.regression,
    ModulePath.configuration,
  ].includes(pathName);

  function handleBreadCrumb() {
    let array = [];

    if (currentUserStoryData && openEditStoryDialog) {
      array.push(currentUserStoryData);
    }

    if (currentUseCaseData && openEditUseCaseDialog) {
      array.push(currentUseCaseData);
    }

    let dataObject = currentFolderData;
    array.push(dataObject);

    while (dataObject?.level > 0) {
      dataObject = dataObject?.parent;
      array.push(dataObject);
    }

    setBreadCrumbsList(array?.reverse());
  }

  const handleLocationPath = useCallback(() => {
    setIsLoading(true);
    const pathArray = currentFolderData?.path?.split("/");

    let locationPathList = [
      {
        name:
          pathName === ModulePath.requirements
            ? Entity_Label.userStory
            : pathName === ModulePath.useCase
              ? Entity_Label.useCase
              : pathName === ModulePath.testCase
                ? Entity_Label.testCase
                : pathName === ModulePath.planning
                  ? Entity_Label.planning
                  : pathName === ModulePath.execution
                    ? Entity_Label.execution
                    : pathName === ModulePath.dashboard
                      ? Entity_Label.dashboard
                      : pathName === ModulePath.configuration
                        ? Entity_Label.configuration
                        : pathName === ModulePath.task
                          ? Entity_Label.task
                          : pathName === ModulePath.regression
                            ? Entity_Label.regression
                            : Entity_Label.configuration,
        type: "section",
      },
    ];

    if (
      pathName === ModulePath.requirements ||
      pathName === ModulePath.useCase ||
      pathName === ModulePath.testCase ||
      pathName === ModulePath.planning ||
      pathName === ModulePath.execution
    ) {
      if (pathArray?.length > 0) {
        locationPathList = locationPathList.concat(
          pathArray?.map((item) => ({
            name: item,
            type: Entity.folder,
          })),
        );
      }
    } else if (pathName === ModulePath.dashboard) {
      locationPathList?.push({
        name: activeDashboard,
        type: Entity.dashboard,
      });

      if (
        activeDashboard === Dashboard_Entity.project.value ||
        activeDashboard === Dashboard_Entity.userStory.value ||
        activeDashboard === Dashboard_Entity.useCase.value ||
        activeDashboard === Dashboard_Entity.testCase.value
      ) {
        locationPathList?.push({
          name:
            activeDashboardModule?.charAt(0)?.toUpperCase() +
            activeDashboardModule.slice(1),
          type: Entity.dashboard,
        });
      }
    } else if (pathName === ModulePath.configuration) {
      locationPathList?.push({
        name: activeConfiguration?.value,
        type: Entity.configuration,
      });
    }

    if (openEditStoryDialog && currentUserStoryData) {
      locationPathList?.push({
        name: currentUserStoryData?.title,
        type: Entity.userStory,
      });
    }

    if (openEditUseCaseDialog && currentUseCaseData) {
      locationPathList?.push({
        name: currentUseCaseData?.title,
        type: Entity.useCase,
      });
    }

    setLocationPathList(locationPathList);

    setTimeout(() => {
      setIsLoading(false);
    }, 100);
  }, [
    currentFolderData,
    currentUserStoryData,
    currentUseCaseData,
    pathName,
    activeDashboard,
    activeDashboardModule,
    activeConfiguration,
    openEditStoryDialog,
    openEditUseCaseDialog,
  ]);

  const handleClickPathItem = (itemData, index) => {
    let itemIndex = index;
    if (itemData?.type === "section" || itemData?.type === Entity.project) {
      setOpenCreateStoryDialog(false);
      setOpenCreateUseCaseDialog(false);
      setCurrentFolderData(null);
    }
    if (
      itemData?.type !== Entity.userStory &&
      itemData?.type !== Entity.useCase &&
      itemData?.type !== Entity.testCase
    ) {
      setOpenEditStoryDialog(false);
      setOpenEditUseCaseDialog(false);
    }

    if (
      itemData?.type !== Entity.folder &&
      itemData?.type?.toLowerCase() !== Entity.release?.toLowerCase()
    )
      return;

    const pathNames = locationPathList?.map((item) => item?.name);

    pathNames?.splice(0, 1);
    itemIndex = itemIndex - 1;

    const urlUpToIndex = pathNames?.slice(0, itemIndex + 1).join("/");
    let folder = findFolder(folderStructureList, "path", urlUpToIndex);

    if (folder) {
      setCurrentFolderData(folder);
    }
  };

  function findFolder(list, keyName, value) {
    if (list && keyName && value) {
      for (const item of list) {
        if (item[keyName]?.toLowerCase() === value?.toLowerCase()) {
          return item;
        }

        if (item.children) {
          const foundInChildren = findFolder(item.children, keyName, value);
          if (foundInChildren) {
            return foundInChildren;
          }
        }
      }
      return null;
    }
  }

  const handleOpenCreateDialog = () => {
    if (pathName === ModulePath.requirements) {
      setOpenCreateStoryDialog(true);
    }
    if (pathName === ModulePath.useCase || pathName === ModulePath.testCase) {
      setOpenCreateUseCaseDialog(true);
    }

    if (pathName === ModulePath.task) {
      setOpenCreateTaskDialog(true);
    }
  };

  function handleComponent() {
    switch (pathName) {
      case ModulePath.requirements:
        return <UserStoryContainerComponent />;
      case ModulePath.useCase:
        return <UseCaseContainerComponent />;
      case ModulePath.testCase:
        return <TestCaseContainerComponent />;
      case ModulePath.planning:
        return <PlanningContainerComponent />;
      case ModulePath.execution:
        return <ExecutionContainerComponent />;
      case ModulePath.dashboard:
        return <DashboardContainerComponent />;
      case ModulePath.task:
        return <TaskContainer />;
      case ModulePath.regression:
        return <RegressionContainer />;
      case ModulePath.configuration:
        return <ConfigurationContainerComponent />;
              case ModulePath.marketplace:
        return <MarketplaceDashboard />;
      default:
        return <UserStoryContainerComponent />;
    }
  }

  const handleMainComponent = () => {
    if (openCreateStoryDialog) {
      return (
        <CreateStoryComponent
          open={openCreateStoryDialog}
          closeDialog={() => setOpenCreateStoryDialog(false)}
        />
      );
    }

    if (!openCreateStoryDialog && openEditStoryDialog && currentUserStoryData) {
      return (
        <EditStoryComponent
          open={openEditStoryDialog}
          closeDialog={() => {
            setOpenEditStoryDialog(false);
            setIsItemChatWindow(false);
            setCurrentUserStoryData(null);
            setSearchParams({});
          }}
        />
      );
    }

    if (openCreateUseCaseDialog && pathName === ModulePath.useCase) {
      return (
        <CreateUseCaseComponent
          open={openCreateUseCaseDialog}
          closeDialog={() => setOpenCreateUseCaseDialog()}
        />
      );
    }

    if (
      !openCreateUseCaseDialog &&
      openEditUseCaseDialog &&
      currentUseCaseData &&
      pathName === ModulePath.useCase
    ) {
      return (
        <EditUseCaseComponent
          open={openEditUseCaseDialog}
          closeDialog={() => {
            setOpenEditUseCaseDialog(false);
            setIsItemChatWindow(false);
            setCurrentUseCaseData(null);
            setSearchParams({});
          }}
        />
      );
    }

    if (openCreateUseCaseDialog && pathName === ModulePath.testCase) {
      return (
        <CreateTestCaseComponent
          open={openCreateUseCaseDialog}
          closeDialog={() => setOpenCreateUseCaseDialog()}
        />
      );
    }

    if (
      !openCreateUseCaseDialog &&
      openEditUseCaseDialog &&
      currentUseCaseData &&
      pathName === ModulePath.testCase
    ) {
      return (
        <EditTestCaseComponent
          open={openEditUseCaseDialog}
          closeDialog={() => {
            setOpenEditUseCaseDialog(false);
            setIsItemChatWindow(false);
            setCurrentUseCaseData(null);
            setSearchParams({});
          }}
        />
      );
    }
  };

  // user story
  const handleGetUserStoryList = async () => {
    try {
      setIsUserStoryLoading(true);

      let body = {
        folderPath: currentFolderData?.path,
        projectName: activeProject?.name,
      };

      const response = await getStoryList_API(body);
      console.log(response, "response handleGetUserStoryList");

      if (response) {
        errorHandler(response, setIsUserStoryLoading);
      }

      if (response.status === HttpStatusCode.Ok) {
        setUserStoryList(
          response.data?.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
          ),
        );
      }
    } catch (error) {
      console.log(error, error?.message, "projectreponse errorr");
      handleSnackbar(String(error), Severity.error);
    } finally {
      setTimeout(() => {
        setIsUserStoryLoading(false);
      }, 1000);
    }
  };

  const handleGetUserStoryListAll = async () => {
    try {
      setIsUserStoryLoading(true);

      let query = `name=${activeProject?.name}`;

      const response = await getStoryListAll_API(query);
      console.log(response, "response handleGetUserStoryList");

      if (response) {
        errorHandler(response, setIsUserStoryLoading);
      }

      if (response.status === HttpStatusCode.Ok) {
        setUserStoryList(
          response.data?.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
          ),
        );
      }
    } catch (error) {
      console.log(error, error?.message, "projectreponse errorr");
      handleSnackbar(String(error), Severity.error);
    } finally {
      setTimeout(() => {
        setIsUserStoryLoading(false);
      }, 0);
    }
  };

  const handleGetUserStoryPropertiesList = async () => {
    try {
      const response = await getStoryPropertiesList_API();
      console.log(response, "response handleGetUserStoryList");

      if (response) {
        errorHandler(response, setIsUserStoryLoading);
      }

      if (response.status === HttpStatusCode.Ok) {
        setUserStoryPropertiesData(response.data);
      }
    } catch (error) {
      console.log(error, error?.message, "projectreponse errorr");
      handleSnackbar(String(error), Severity.error);
    } finally {
      setTimeout(() => {
        setIsUserStoryLoading(false);
      }, 0);
    }
  };

  const handleCreateStory = async (storyData) => {
    try {
      let body = {
        ...storyData,
        priority: "High",
        moduleName: currentFolderData?.name,
        projectName: activeProject?.name,
      };

      const response = await addStory_API(body);
      console.log(response, "response handleCreateStory");

      if (response) {
        errorHandler(response);
      }

      if (response.status === HttpStatusCode.Ok) {
        handleGetUserStoryList();
        setOpenCreateStoryDialog(false);
      }

      setIsUpdateFolderStructure(true);

      console.log(response, "projectreponse data");
    } catch (error) {
      console.log(error, error?.message, "projectreponse errorr");
      handleSnackbar(String(error), Severity.error);
    } finally {
      setTimeout(() => {}, 1000);
    }
  };

  const handleUpdateStory = async (storyData) => {
    try {
      let body = {
        ...storyData,
      };

      const response = await updateStory_API(body);
      console.log(response, "response handleUpdateStory");

      if (response) {
        errorHandler(response);
      }

      if (response?.status === HttpStatusCode.Ok) {
        handleGetUserStoryList();
        setOpenEditStoryDialog(false);
      }

      console.log(response, "projectreponse data");
    } catch (error) {
      console.log(error, error?.message, "projectreponse errorr");
      handleSnackbar(String(error), Severity.error);
    } finally {
      setTimeout(() => {}, 1000);
    }
  };

  const handleDeleteStory = async (storyData) => {
    try {
      let body = {
        customId: storyData?.customId,
        moduleName: currentFolderData?.name,
        projectName: activeProject?.name,
      };

      const response = await deleteStory_API(body);

      if (response.status === HttpStatusCode.Ok) {
        // handleSnackbar(response?.message, Severity.success);
        // setOpenDeleteStoryDialog(false);
      }

      if (response) {
        errorHandler(response);
      }

      setTimeout(() => {}, 1000);

      console.log(response, "projectreponse data");
    } catch (error) {
      console.error(error, "projectreponse errorr");
    }
  };

  // use case
  const handleGetUseCaseList = async () => {
    try {
      setIsActiveProjectContainerLoading(true);

      let body = {
        folderPath: currentFolderData?.path,
        projectName: activeProject?.name,
      };

      const response = await getUseCaseList_API(body);
      console.log(response, "response handleGetUseCaseList");

      if (response) {
        errorHandler(response, setIsActiveProjectContainerLoading);
      }

      if (response.status === HttpStatusCode.Ok) {
        setUseCaseList(
          response.data?.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
          ),
        );
      }
    } catch (error) {
      console.log(error, error?.message, "projectreponse errorr");
      handleSnackbar(String(error), Severity.error);
    } finally {
      setTimeout(() => {
        setIsActiveProjectContainerLoading(false);
      }, 1000);
    }
  };

  const handleGetUseCaseListAll = async () => {
    try {
      setIsActiveProjectContainerLoading(true);

      let query = `name=${activeProject?.name}`;

      const response = await getUseCaseListAll_API(query);
      console.log(response, "response handleGetUseCaseList");

      if (response) {
        errorHandler(response, setIsActiveProjectContainerLoading);
      }

      if (response.status === HttpStatusCode.Ok) {
        setUseCaseList(
          response.data?.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
          ),
        );
      }
    } catch (error) {
      console.log(error, error?.message, "projectreponse errorr");
      handleSnackbar(String(error), Severity.error);
    } finally {
      setTimeout(() => {
        setIsActiveProjectContainerLoading(false);
      }, 1000);
    }
  };

  const handleGetUseCasePropertiesList = async () => {
    try {
      const response = await getUseCasePropertiesList_API();
      console.log(response, "response handleGetUserStoryList");

      if (response) {
        errorHandler(response, setIsActiveProjectContainerLoading);
      }

      if (response.status === HttpStatusCode.Ok) {
        setUseCasePropertiesData(response.data);
      }
    } catch (error) {
      console.log(error, error?.message, "projectreponse errorr");
      handleSnackbar(String(error), Severity.error);
    } finally {
      setTimeout(() => {
        setIsActiveProjectContainerLoading(false);
      }, 1000);
    }
  };

  const handleCreateUseCase = async (storyData) => {
    try {
      let body = {
        ...storyData,
      };

      const response = await addUseCase_API(body);
      console.log(response, "response handleCreateStory");

      if (response) {
        errorHandler(response);
      }

      if (response.status === HttpStatusCode.Ok) {
        handleGetUseCaseList();
        setOpenCreateUseCaseDialog(false);
      }

      setIsUpdateFolderStructure(true);

      console.log(response, "projectreponse data");
    } catch (error) {
      console.log(error, error?.message, "projectreponse errorr");
      handleSnackbar(String(error), Severity.error);
    } finally {
      setTimeout(() => {}, 1000);
    }
  };

  const handleUpdateUseCase = async (storyData) => {
    try {
      let body = {
        ...storyData,
      };

      const response = await updateUseCase_API(body);
      console.log(response, "response handleUpdateStory");

      if (response) {
        errorHandler(response);
      }

      if (response?.status === HttpStatusCode.Ok) {
        handleGetUseCaseList();
        setOpenEditStoryDialog(false);
      }

      console.log(response, "projectreponse data");
    } catch (error) {
      console.log(error, error?.message, "projectreponse errorr");
      handleSnackbar(String(error), Severity.error);
    } finally {
      setTimeout(() => {}, 1000);
    }
  };

  const handleDeleteUseCase = async (storyData) => {
    try {
      let body = {
        customId: storyData?.customId,
        moduleName: currentFolderData?.name,
        projectName: activeProject?.name,
      };

      const response = await deleteUseCase_API(body);

      if (response.status === HttpStatusCode.Ok) {
        // handleSnackbar(response?.message, Severity.success);
        // setOpenDeleteStoryDialog(false);
      }

      if (response) {
        errorHandler(response);
      }

      setTimeout(() => {}, 1000);

      console.log(response, "projectreponse data");
    } catch (error) {
      console.error(error, "projectreponse errorr");
    }
  };

  // test case - FIXED: Set to testCaseList instead of useCaseList
  const handleGetTestCaseList = async () => {
    try {
      setIsActiveProjectContainerLoading(true);

      let body = {
        folderPath: currentFolderData?.path,
        projectName: activeProject?.name,
      };

      const response = await getTestCaseList_API(body);
      console.log(response, "response handleGetTestCaseList");

      if (response) {
        errorHandler(response, setIsActiveProjectContainerLoading);
      }

      if (response.status === HttpStatusCode.Ok) {
        // FIX: Set to testCaseList, not useCaseList
        setTestCaseList(
          response.data?.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
          ),
        );
      }
    } catch (error) {
      console.log(error, error?.message, "projectreponse errorr");
      handleSnackbar(String(error), Severity.error);
    } finally {
      setTimeout(() => {
        setIsActiveProjectContainerLoading(false);
      }, 1000);
    }
  };

  const handleGetTestCaseListAll = async () => {
    try {
      setIsActiveProjectContainerLoading(true);

      let query = `name=${activeProject?.name}`;

      const response = await getTestCaseListAll_API(query);
      console.log(response, "response handleGetTestCaseListAll");

      if (response) {
        errorHandler(response, setIsActiveProjectContainerLoading);
      }

      if (response.status === HttpStatusCode.Ok) {
        // FIX: Set to testCaseList, not useCaseList
        setTestCaseList(
          response.data?.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
          ),
        );
      }
    } catch (error) {
      console.log(error, error?.message, "projectreponse errorr");
      handleSnackbar(String(error), Severity.error);
    } finally {
      setTimeout(() => {
        setIsActiveProjectContainerLoading(false);
      }, 1000);
    }
  };

  const handleGetTestCasePropertiesList = async () => {
    try {
      const response = await getTestCasePropertiesList_API();
      console.log(response, "response handleGetTestCasePropertiesList");

      if (response) {
        errorHandler(response, setIsActiveProjectContainerLoading);
      }

      if (response.status === HttpStatusCode.Ok) {
        // You might want to create a separate state for test case properties
        // For now, using useCasePropertiesData
        setUseCasePropertiesData(response.data);
      }
    } catch (error) {
      console.log(error, error?.message, "projectreponse errorr");
      handleSnackbar(String(error), Severity.error);
    } finally {
      setTimeout(() => {
        setIsActiveProjectContainerLoading(false);
      }, 1000);
    }
  };

  const handleGetDashboardReport = async () => {
    try {
      let body = {
        projectName: activeProject?.name,
        startDate: startDate
          ? dayjs(startDate)
              .add(0, "hour")
              .add(0, "minute")
              .add(0, "second")
              .toISOString()
          : "",
        endDate: endDate
          ? dayjs(endDate)
              .add(23, "hour")
              .add(59, "minute")
              .add(0, "second")
              .toISOString()
          : "",
        creationDate: selectedCalenderDate
          ? dayjs(selectedCalenderDate).add(1, "day")
          : "",
      };

      const response = await getDashboardReportList_API(body);
      console.log(response, "response handleGetUserStoryList");

      if (response) {
        errorHandler(response);
      }

      if (response.status === HttpStatusCode.Ok) {
        let responseList = response.data;
        if (selectedLevel === Entity.release) {
          responseList = responseList?.filter(
            (item, index) => item?.releaseName,
          );
        }
        setDashboardReportList(responseList);
      }
    } catch (error) {
      console.log(error, error?.message, "projectreponse errorr");
      handleSnackbar(String(error), Severity.error);
    }
  };

  // fetch the userstory / usecase / testcase list
  useEffect(() => {
    const func = debounce(() => {
      if (pathName === ModulePath.requirements) {
        if (currentFolderData && currentFolderData.type !== Entity.userStory) {
          handleGetUserStoryList();
        } else if (currentFolderData?.type !== Entity.userStory) {
          if (activeProject && !isLoading) {
            handleGetUserStoryListAll();
          }
        }
      }

      if (pathName === ModulePath.useCase) {
        if (currentFolderData && currentFolderData.type !== Entity.useCase) {
          handleGetUseCaseList();
        } else if (currentFolderData?.type !== Entity.useCase) {
          if (activeProject && !isLoading) {
            handleGetUseCaseListAll();
          }
        }
      }

      if (pathName === ModulePath.testCase) {
        if (currentFolderData && currentFolderData.type !== Entity.testCase) {
          handleGetTestCaseList();
        } else if (currentFolderData?.type !== Entity.testCase) {
          if (activeProject && !isLoading) {
            handleGetTestCaseListAll();
          }
        }
      }
    }, 200);

    if (
      !isUpdateFolderStructure &&
      !isFolderStructureLoading &&
      folderStructureList?.length > 0
    ) {
      func();
    }
  }, [
    pathName,
    currentFolderData,
    activeProject,
    isUpdateFolderStructure,
    isFolderStructureLoading,
    folderStructureList,
  ]);

  // fetch the properties of userstory / usecase / testcase
  useEffect(() => {
    const func = debounce(() => {
      if (pathName === ModulePath.requirements) {
        handleGetUserStoryPropertiesList();
      }

      if (pathName === ModulePath.useCase) {
        handleGetUseCasePropertiesList();
      }

      if (pathName === ModulePath.testCase) {
        handleGetTestCasePropertiesList();
      }
    }, 100);

    if (
      !isUpdateFolderStructure &&
      !isFolderStructureLoading &&
      folderStructureList?.length > 0
    ) {
      func();
    }
  }, [
    pathName,
    isUpdateFolderStructure,
    isFolderStructureLoading,
    folderStructureList,
  ]);

  useEffect(() => {
    if (
      isFolderStructureLoading &&
      (!isActiveProjectContainerLoading || !isUserStoryLoading)
    ) {
      // setIsActiveProjectContainerLoading(prev => true);
      // setIsUserStoryLoading(prev => true);
    }
  }, [
    isFolderStructureLoading,
    isActiveProjectContainerLoading,
    setIsActiveProjectContainerLoading,
    isUserStoryLoading,
    setIsUserStoryLoading,
  ]);

  // close the dialog when page changes
  useEffect(() => {
    setOpenEditStoryDialog(false);
    setOpenEditUseCaseDialog(false);
    setOpenCreateUseCaseDialog(false);
    setOpenCreateStoryDialog(false);

    setCurrentFilters(null);
  }, [
    pathName,
    setOpenEditStoryDialog,
    setOpenEditUseCaseDialog,
    setOpenCreateUseCaseDialog,
    setOpenCreateStoryDialog,
    setCurrentFilters,
  ]);

  useEffect(() => {
  // Clear dashboard filters when project changes
  setDashboardFilterSelectedRelease("");
  setDashboardFilterSelectedSprint("");
  setSelectedReleaseIndex(null);
  setSelectedSprintIndex(null);
  
  // Also clear any date range filters if you have them
  setDateRange([null, null]);
  setSelectedCalenderDate(null);
  setSelectedLevel(null);
  
}, [
  activeProject, // This will trigger when project changes
  setDashboardFilterSelectedRelease,
  setDashboardFilterSelectedSprint,
  setSelectedReleaseIndex,
  setSelectedSprintIndex,
  setDateRange,
  setSelectedCalenderDate,
  setSelectedLevel,
]);

  // To get the location path of current location
  useEffect(() => {
    const func = debounce(() => {
      if (currentFolderData) {
        handleLocationPath();
      } else {
        handleLocationPath();
      }
    }, 100);

    func();
  }, [
    currentFolderData,
    pathName,
    openEditStoryDialog,
    openEditUseCaseDialog,
    activeDashboard,
    activeDashboardModule,
    activeConfiguration,
  ]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [folderList, setFolderList] = useState([]);

  const handleClick = (event) => {
    setTempSelectedLevel(selectedLevel);
    setTempSelectedCalenderDate(selectedCalenderDate);
    setTempDateRange(dateRange);

    setAnchorEl(event.currentTarget);
  };

  const handleApply = () => {
    setSelectedLevel(tempSelectedLevel);
    setSelectedCalenderDate(tempSelectedCalenderDate);
    setDateRange(tempDateRange);

    handleClose();
  };

  const handleClear = () => {
    setTempSelectedLevel("");
    setTempSelectedCalenderDate(null);
    setTempDateRange([null, null]);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  // To get the dashboard report list
  useEffect(() => {
    if (
      pathName === ModulePath.dashboard &&
      activeDashboard === Dashboard_Entity.report.value
    ) {
      handleGetDashboardReport();
    }
  }, [
    pathName,
    activeDashboard,
    startDate,
    endDate,
    selectedLevel,
    selectedCalenderDate,
  ]);

  // console.log(pathName, "pathName");
  // console.log(testCaseList, "testCaseList in ActiveProjectContainer");

  return (
    <>
      <Box className="flex gap-2 w-full h-full">
        <Box className="flex flex-col gap-2 flex-1 h-full relative overflow-hidden">
          {/* HEADER */}
          <Box
            className={`w-full flex flex-col justify-center mb-2.5 py-1 min-h-10 max-h-12 ${
              pathName === ModulePath.task || pathName === ModulePath.regression
                ? "px-8"
                : "px-4"
            }`}
            borderBottom={`1px solid ${theme.palette.divider}`}
            sx={{
              backgroundColor: theme.palette.background.paper,
              px: 1,
              pt: 1,
              pb: 1,
            }}
          >
            <Box
              className="w-full h-fit flex flex-col justify-center gap-2"
              borderRadius={theme.shape.borderRadius}
            >
              <Box
                className="w-full h-fit flex items-center justify-end gap-"
                sx={{ mt: 1, mb: 1, ml: 2 }}
              >
                {true &&
                  (isLoading ? (
                    <Box className="flex-1 flex items-center gap-2 w-full">
                      {[1, 2].map((item) => (
                        <Skeleton
                          key={item}
                          variant="rounded"
                          width={74}
                          height={26}
                          animation="wave"
                        />
                      ))}
                    </Box>
                  ) : (
                    <Box className="flex-1 flex items-center gap-2">
                      {(pathName === ModulePath.task ||
                        pathName === ModulePath.regression) && (
                        <Box
                          className="flex items-center cursor-pointer rounded p-1"
                          onClick={() => window.history.back()}
                          sx={{
                            "&:hover": { opacity: 0.8 },
                          }}
                        >
                          <ArrowBackOutlined
                            fontSize="small"
                            sx={{
                              color: (theme) => theme.palette.primary.main,
                            }}
                          />
                        </Box>
                      )}

                      <Box className="flex-1 flex ml-2">
                        <Breadcrumbs aria-label="breadcrumb">
                          {locationPathList?.map((item, index, arr) => (
                            <LightTooltip
                              key={index}
                              title={
                                <Typography
                                  fontSize={font.size.fs_6}
                                  color="textPrimary"
                                  className="capitalize"
                                >
                                  {`${
                                    item?.type === Entity.project
                                      ? `${Entity_Label.project}: ${item?.name}`
                                      : item?.type === "section"
                                        ? `Section: ${item?.name}`
                                        : item?.type === Entity.folder
                                          ? `${t("folderText")}: ${item?.name}`
                                          : `${
                                              pathName ===
                                              ModulePath.requirements
                                                ? Entity_Label.userStory
                                                : pathName ===
                                                    ModulePath.useCase
                                                  ? Entity_Label.useCase
                                                  : pathName ===
                                                      ModulePath.testCase
                                                    ? Entity_Label.testCase
                                                    : pathName ===
                                                        ModulePath.dashboard
                                                      ? activeDashboard
                                                      : ""
                                            }: ${item?.name}`
                                  }`}
                                </Typography>
                              }
                            >
                              <Button
                                key={index}
                                color={
                                  arr?.length - 1 === index
                                    ? "secondary"
                                    : "inherit"
                                }
                                disableElevation={
                                  item?.type === Entity.project ||
                                  item?.type === "section"
                                }
                                disableTouchRipple={
                                  item?.type === Entity.project ||
                                  item?.type === "section"
                                }
                                disableRipple={
                                  item?.type === Entity.project ||
                                  item?.type === "section"
                                }
                                className={`flex items-center gap-1 ${
                                  (item?.type === Entity.project ||
                                    item?.type === "section") &&
                                  "cursor-none"
                                }`}
                                sx={{ textTransform: "inherit" }}
                                onClick={() => handleClickPathItem(item, index)}
                              >
                                <Box
                                  className="flex items-center gap-1"
                                  sx={{
                                    color:
                                      arr?.length - 1 === index
                                        ? theme.palette.secondary.main
                                        : theme.palette.text.primary,
                                  }}
                                >
                                  {item?.type === Entity.project ? (
                                    <ProjectCustomIcon
                                      sx={{
                                        color: (theme) =>
                                          theme.palette.primary.main,
                                      }}
                                    />
                                  ) : item?.type === "section" ? (
                                    pathName === ModulePath.requirements ? (
                                      <UserStoryCustomIcon
                                        sx={{
                                          color: (theme) =>
                                            theme.palette.primary.main,
                                        }}
                                      />
                                    ) : pathName === ModulePath.useCase ? (
                                      <UseCaseCustomIcon
                                        sx={{
                                          color: (theme) =>
                                            theme.palette.primary.main,
                                        }}
                                      />
                                    ) : (
                                      <TestCaseCustomIcon
                                        sx={{
                                          color: (theme) =>
                                            theme.palette.primary.main,
                                        }}
                                      />
                                    )
                                  ) : item?.type === Entity.folder ? (
                                    <FolderCustomIcon
                                      sx={{
                                        color: (theme) =>
                                          theme.palette.primary.main,
                                      }}
                                    />
                                  ) : item?.type === Entity.dashboard ? (
                                    <DashboardCustomIcon
                                      sx={{
                                        color: (theme) =>
                                          theme.palette.primary.main,
                                      }}
                                    />
                                  ) : pathName === ModulePath.requirements ? (
                                    <UserStoryCustomIcon
                                      sx={{
                                        color: (theme) =>
                                          theme.palette.primary.main,
                                      }}
                                    />
                                  ) : pathName === ModulePath.useCase ? (
                                    <UseCaseCustomIcon
                                      sx={{
                                        color: (theme) =>
                                          theme.palette.primary.main,
                                      }}
                                    />
                                  ) : (
                                    <TestCaseCustomIcon
                                      sx={{
                                        color: (theme) =>
                                          theme.palette.primary.main,
                                      }}
                                    />
                                  )}
                                  <Typography
                                    fontSize={font.size.fs_6}
                                    className="truncate max-w-44"
                                    sx={{
                                      color: (theme) =>
                                        theme.palette.primary.main,
                                    }}
                                  >
                                    {item?.name}
                                  </Typography>
                                </Box>
                              </Button>
                            </LightTooltip>
                          ))}
                        </Breadcrumbs>
                      </Box>
                    </Box>
                  ))}

                {pathName === ModulePath.task && (
                  <Box className="flex items-center gap-2 pr-5 ">
                    <LightTooltip title="Create New Task">
                      <Button
                        variant="contained"
                        color="secondary"
                        startIcon={<Add />}
                        onClick={() => {
                          handleOpenCreateDialog();
                        }}
                        sx={{
                          textTransform: "none",
                          borderRadius: "8px",
                          px: 2,
                          py: 1,
                          fontWeight: 500,
                          whiteSpace: "nowrap",
                          minWidth: "auto",
                          background: `linear-gradient(135deg, ${colors.cyan}, ${colors.emerald})`,
                          color: colors.background,
                          boxShadow: `0 0 20px ${colors.cyan}33, 0 0 40px ${colors.cyan}22`,
                          transition: "all 0.3s ease",
                          "&:hover": {
                            background: `linear-gradient(135deg, ${colors.cyan}, ${colors.emerald})`,
                            boxShadow: `0 0 30px ${colors.cyan}66, 0 0 60px ${colors.cyan}33`,
                            transform: "translateY(-2px)",
                          },
                        }}
                      >
                        Create Task
                      </Button>
                    </LightTooltip>
                  </Box>
                )}

{pathName === ModulePath.dashboard && !openEditReportDialog && (
  <Box className="pr-5 flex gap-4">
    <Button
      variant="outlined"
      onClick={() => setOpenDashItemFilterDrawer(true)}
      startIcon={<FilterList fontSize="small" />}
      sx={{
        textTransform: "none",
        borderRadius: "8px",
        px: 2,
        py: 0.7,
        fontWeight: 500,
        gap: 1,
      }}
    >
      Filter
    </Button>

    {/* Selected Filters Display */}
    {(dashboardFilterSelectedRelease || dashboardFilterSelectedSprint) && (
      <Box className="flex items-center gap-2">
        {dashboardFilterSelectedRelease && (
          <Chip
            label={`Release: ${dashboardFilterSelectedRelease}`}
            onDelete={() => {
              setDashboardFilterSelectedRelease("");
              setDashboardFilterSelectedSprint("");
              setSelectedReleaseIndex(null);
              setSelectedSprintIndex(null);
            }}
            size="small"
            color="primary"
            variant="outlined"
            deleteIcon={<Close fontSize="small" />}
            sx={{
              borderRadius: '6px',
              '& .MuiChip-label': {
                fontWeight: 500,
              },
            }}
          />
        )}
        
        {dashboardFilterSelectedSprint && (
          <Chip
            label={`Sprint: ${dashboardFilterSelectedSprint}`}
            onDelete={() => {
              setDashboardFilterSelectedSprint("");
              setSelectedSprintIndex(null);
            }}
            size="small"
            color="primary"
            variant="outlined"
            deleteIcon={<Close fontSize="small" />}
            sx={{
              borderRadius: '6px',
              '& .MuiChip-label': {
                fontWeight: 500,
              },
            }}
          />
        )}
      </Box>
    )}

    {/* Clear All Button - Only show when both filters are selected */}
    {dashboardFilterSelectedRelease && dashboardFilterSelectedSprint && (
      <Button
        variant="outlined"
        onClick={() => {
          setSelectedReleaseIndex(null);
          setSelectedSprintIndex(null);
          setDashboardFilterSelectedSprint("");
          setDashboardFilterSelectedRelease("");
        }}
        startIcon={<ClearAll fontSize="small" />}
        sx={{
          textTransform: "none",
          borderRadius: "8px",
          px: 2,
          py: 0.7,
          fontWeight: 500,
          color: "error.main",
          borderColor: "error.main",
          '&:hover': {
            borderColor: "error.dark",
            backgroundColor: "error.light",
            color: "error.dark",
          },
        }}
      >
        Clear All
      </Button>
    )}

    <Suspense fallback={<FallbackUILoader />}>
      {openDashItemFilterDrawer && (
        <FilterDrawerItemDrawer
          open={openDashItemFilterDrawer}
          onClose={() => {
            setOpenDashItemFilterDrawer(false);
          }}
        />
      )}
    </Suspense>
  </Box>
)}
              </Box>
            </Box>
          </Box>

          {/* BODY */}
          <Box className="grow flex flex-col relative overflow-hidden px-4 py-0">
            {!openEditStoryDialog &&
              !openEditUseCaseDialog &&
              !openCreateStoryDialog &&
              !openCreateUseCaseDialog &&
              handleComponent()}

            {(openEditStoryDialog ||
              openEditUseCaseDialog ||
              openCreateStoryDialog ||
              openCreateUseCaseDialog) && (
              <Box
                className="flex flex-col absolute left-0 top-0 bottom-0 right-0 z-10 px-4 py-0 bg-background-default"
                sx={{
                  backgroundColor: theme.palette.background.default,
                  boxShadow: theme.shadows[3],
                }}
              >
                <Suspense fallback={<FallbackUILoader />}>
                  {handleMainComponent()}
                </Suspense>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
}

function UserStoryContainerComponent() {
  const {
    isGridViewEnabled,
    setIsGridViewEnabled,
    handleSnackbar,
    currentFolderData,
    setCurrentFolderData,
    userStoryList,
    setUserStoryList,
    currentUserStoryData,
    setCurrentUserStoryData,
    isShowStoryFilter,
    setIsShowStoryFilter,
    selectedUserStoryList,
    setSelectedUserStoryList,
    isUserStoryLoading,
    setIsUserStoryLoading,
    filteredUserStoryList,
    setFilteredUserStoryList,
    openDeleteStoryDialog,
    setOpenDeleteStoryDialog,
    openCreateStoryDialog,
    currentFilters,
    setCurrentFilters,
    openItemFilterDrawer,
    setOpenItemFilterDrawer,
    userStoryPropertiesData,
    setUserStoryPropertiesData,
    activeProject,
  } = useApplicationContext();
  const {
    labelList,
    setLabelList,
    selectedLabels,
    setSelectedLabels,
    labelAnchorEl,
    setLabelAnchorEl,
    searchText,
    setSearchText,
    loading,
    setLoading,
    openLabelDialog,
    setOpenLabelDialog,
    isLabelEditMode,
    setIsLabelEditMode,
    currentLabelData,
    setCurrentLabelData,
    labelData,
    setLabelData,
    handleToggleLabelPopup,
    handleChangeLabel,
    handleOpenLabelAddUpdate_Dialog,
    handleLabelUpdate,
    handleAddLabel,
    handleCloseDialog,
    handleClickLabelButton,
    handleGetList,
    setOpenCreateStoryDialog,
  } = useApplicationContext();

  const theme = useTheme();
  const errorHandler = useErrorHandler();

  const pathName = useLocation()?.pathname;
  const { t } = useTranslation("translation", { keyPrefix: "activeProject" });

  const isTabletScreen = useMediaQuery((theme) => theme.breakpoints.down("xl"));

  const [activeTab, setActiveTab] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowFilters, setIsShowFilters] = useState(true);
  const [actionType, setActionType] = useState("label");
  const [actionIconAnchorEl, setActionIconAnchorEl] = useState(null);
  const [moreAnchorEl, setMoreAnchorEl] = useState(null);
  const [selectedStory, setSelectedStory] = useState(null);

  const [finalList, setFinalList] = useState(filteredUserStoryList);
  const [selectedPropertiesData, setSelectedPropertiesData] = useState(null);

  const [stateList, setStateList] = useState([]);
  const [moscowList, setMoscowList] = useState([]);
  const [confidentialityList, setConfidentialityList] = useState([]);
  const [typeList, setTypeList] = useState([]);
  const [priorityList, setPriorityList] = useState([]);

  const hasNoData = userStoryList?.length === 0;
  const showDisabledOverlay = hasNoData;

  // ADD THESE STATE VARIABLES HERE
  const [openActionDialog, setOpenActionDialog] = useState(false);
  const [actionDialogType, setActionDialogType] = useState(null); // 'copy' or 'move'
  const [selectedItemsForAction, setSelectedItemsForAction] = useState([]);

  const MoveCopyDialog = lazy(() => import("../../dialog/MoveCopyDialog"));

  const handleChangeSearch = debounce((value) => {
    setSearchText(value);
  }, 300);

  const handleDeleteClick = () => {
    setOpenDeleteStoryDialog(true);
    // console.log(openDeleteStoryDialog, "true");
  };

  const handleRemoveFilterItem = (key, value) => {
    let filter = currentFilters ? { ...currentFilters } : {};

    if (Array.isArray(filter[key])) {
      filter[key] = currentFilters[key].filter((item) => item !== value);
      if (filter[key].length === 0) {
        delete filter[key];
      }
    } else {
      if (key === "from") {
        delete filter["createdAt"][key];
      }

      if (key === "to") {
        delete filter["createdAt"][key];
      }

      if (
        filter["createdAt"] &&
        Object.keys(filter["createdAt"])?.length === 0
      ) {
        delete filter["createdAt"];
      } else {
        delete filter[key];
      }
    }

    if (filter && Object.keys(filter)?.length === 0) {
      setCurrentFilters(null);
      return;
    }

    setCurrentFilters(filter);
  };

  const handleGetFilterCount = (value) => {
    if (value === Filters.status) {
      return currentFilters?.status?.length;
    }

    if (value === Filters.createdAt) {
      return currentFilters?.createdAt?.from && currentFilters?.createdAt?.to
        ? 2
        : currentFilters?.createdAt?.from
          ? 1
          : currentFilters?.createdAt?.to
            ? 1
            : 0;
    }
  };

  const handleChangeColumnFilter = (event, key) => {
    const filterData = currentFilters ? { ...currentFilters } : {};

    if (event.target.value === "") {
      delete filterData[key];
    } else {
      filterData[key] = event.target.value;
    }

    setCurrentFilters(filterData);
  };

  const handleToggleActionMenu = (event, actionType) => {
    if (!actionIconAnchorEl) {
      setActionIconAnchorEl(event.currentTarget);
      setActionType(actionType);
    } else {
      setActionIconAnchorEl(null);
    }
  };

  const handleToggleMoreMenu = (event) => {
    if (!moreAnchorEl) {
      setMoreAnchorEl(event.currentTarget);
    } else {
      setMoreAnchorEl(null);
    }
  };

  const handleSelectProperites = (key, value) => {
    setSelectedPropertiesData({ ...selectedPropertiesData, [key]: value });
  };

  const handleCancelPropertiesData = () => {
    setSelectedPropertiesData(null);
    setActionIconAnchorEl(null);
  };

  const handleApplyPropertiesData = () => {
    let body = {
      customIds: [selectedUserStoryList?.map((item) => item?.customId)],
      folderPath: currentFolderData?.path,
      projectName: activeProject?.name,
    };

    body = { ...body, ...selectedPropertiesData };

    handleUpdateStory(body);
  };

  const handleUpdateStory = async (storyData) => {
    try {
      setIsUserStoryLoading(true);

      let body = {
        ...storyData,
      };

      const bodyFormData = new FormData();
      Object.keys(body).forEach((key) => {
        if (Array.isArray(body[key])) {
          bodyFormData.append(key, body[key]);
        } else {
          bodyFormData.append(key, body[key]);
        }
      });

      const response = await updateStory_API(bodyFormData);
      // console.log(response, "response handleUpdateStory");

      if (response) {
        errorHandler(response, setIsUserStoryLoading);
      }

      if (response?.status === HttpStatusCode.Ok) {
        let updatedList = response.data;

        updatedList?.forEach((item) => {
          let list = userStoryList;
          let foundIndex = list?.findIndex(
            (listItem) => listItem?.customId === item?.customId,
          );
          if (foundIndex !== -1) {
            list[foundIndex] = item;
          }
          setUserStoryList(
            list?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)),
          );
        });

        setSelectedUserStoryList([]);
        setActionIconAnchorEl(null);
        setSelectedPropertiesData(null);

        setTimeout(() => {
          handleSnackbar("Story updated successfully", Severity.success);
        }, 500);
      }

      console.log(response, "projectreponse data");
    } catch (error) {
      // console.log(error, error?.message, "projectreponse errorr");
      handleSnackbar(String(error), Severity.error);
    } finally {
      setTimeout(() => {
        setIsUserStoryLoading(false);
      }, 1000);
    }
  };

useEffect(() => {
  setIsLoading(isUserStoryLoading);
}, [isUserStoryLoading]);

useEffect(() => {
  setIsLoading(true);

  let timer;

  if (currentFilters) {
    const filteredRows = userStoryList?.filter((row) =>
      Object.entries(currentFilters).every(([column, value]) => {
        if (!value) return true;

        if (Array.isArray(value)) {
          return value.includes(row[column]?.toString());
        }

        if (column === "createdAt") {
          if (value.from && value.to) {
            return (
              dayjs(row.createdAt).isAfter(dayjs(value.from), "day") &&
              dayjs(row.createdAt).isBefore(dayjs(value.to), "day")
            );
          } else if (value.from) {
            return (
              dayjs(row.createdAt).isAfter(dayjs(value.from), "day") ||
              dayjs(row.createdAt).isSame(dayjs(value.from), "day")
            );
          } else if (value.to) {
            return (
              dayjs(row.createdAt).isBefore(dayjs(value.to), "day") ||
              dayjs(row.createdAt).isSame(dayjs(value.to), "day")
            );
          }
          return false;
        }

        return row[column]
          ?.toString()
          .toLowerCase()
          .includes(value.toLowerCase());
      })
    );

    setFilteredUserStoryList(filteredRows);
  } else {
    setFilteredUserStoryList(userStoryList);
  }

  timer = setTimeout(() => {
    setIsLoading(false);
  }, 300);

  return () => clearTimeout(timer);
}, [currentFilters, userStoryList]);

  useEffect(() => {
    let list = filteredUserStoryList;

    if (searchText) {
      list = list?.filter(
        (item) =>
          item?.customId?.toLowerCase()?.includes(searchText.toLowerCase()) ||
          item?.title?.toLowerCase()?.includes(searchText.toLowerCase()) ||
          item?.state?.toLowerCase()?.includes(searchText.toLowerCase()) ||
          item?.priority?.toLowerCase()?.includes(searchText.toLowerCase()) ||
          item?.type?.toLowerCase()?.includes(searchText.toLowerCase()) ||
          item?.moscow?.toLowerCase()?.includes(searchText.toLowerCase()) ||
          item?.confidentiality
            ?.toLowerCase()
            ?.includes(searchText.toLowerCase()),
      );
    }

    setFinalList(list);
  }, [searchText, filteredUserStoryList, setFinalList]);

  useEffect(() => {
    setFilteredUserStoryList(userStoryList);
  }, [userStoryList, setFilteredUserStoryList]);

  useEffect(() => {
    if (userStoryPropertiesData) {
      setTypeList(userStoryPropertiesData["type"]);
      setStateList(userStoryPropertiesData["state"]);
      setPriorityList(userStoryPropertiesData["priority"]);
      setMoscowList(userStoryPropertiesData["moscow"]);
      setConfidentialityList(userStoryPropertiesData["confidentiality"]);
    }
  }, [userStoryPropertiesData]);

  // console.log(isTabletScreen, "isTabletScreen");
  // console.log(selectedPropertiesData, "selectedPropertiesData");
  // console.log(currentFilters, "currentFiltersss");

  const handleApplyLabels = async (labels) => {
    if (!selectedUserStoryList || selectedUserStoryList.length === 0) return;

    try {
      setLoading(true);

      for (const story of selectedUserStoryList) {
        const payload = {
          customIds: [story.customId],
          lastModifiedAt: story.lastModifiedAt,
          folderPath: story.folderPath,
          projectName: activeProject?.name,
          labels: labels.map((l) => l.name).join(","),
        };

        const formData = new FormData();
        Object.keys(payload).forEach((key) => {
          if (Array.isArray(payload[key])) {
            formData.append(key, payload[key].join(","));
          } else {
            formData.append(key, payload[key]);
          }
        });

        await updateStory_API(formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        const index = userStoryList.findIndex(
          (item) => item.customId === story.customId,
        );
        if (index !== -1) {
          const updatedStory = {
            ...story,
            labels: labels.map((l) => ({
              name: l.name,
              colorCode: l.color,
            })),
          };
          const newList = [...userStoryList];
          newList[index] = updatedStory;
          setUserStoryList(newList);
        }
      }

      handleSnackbar("Labels updated successfully", Severity.success);
      setLabelAnchorEl(null);
    } catch (err) {
      console.error(err);
      handleSnackbar(err.message, Severity.error);
    } finally {
      setLoading(false);
    }
  };
  // to refresh list
  // const refreshUserStories = async () => {
  //   setIsUserStoryLoading(true);
  //   try {
  //     const response = await getUserStoryList_API({ projectName: activeProject?.name });
  //     if (response.status === 200) {
  //       setUserStoryList(response.data || []);
  //     }
  //   } catch (error) {
  //     handleSnackbar("Failed to refresh user stories", "error");
  //   } finally {
  //     setIsUserStoryLoading(false);
  //   }
  // };
  const handleMoveAction = () => {
    const items = selectedUserStoryList;
    if (!items || items.length === 0) {
      handleSnackbar("Please select items to move", "warning");
      return;
    }
    setSelectedItemsForAction(items);
    setActionDialogType("move");
    setOpenActionDialog(true);
  };

  const handleCopyAction = () => {
    const items = selectedUserStoryList;
    if (!items || items.length === 0) {
      handleSnackbar("Please select items to copy", "warning");
      return;
    }
    setSelectedItemsForAction(items);
    setActionDialogType("copy");
    setOpenActionDialog(true);
  };
  const handleGetUserStoryList = async () => {
    try {
      setIsUserStoryLoading(true);

      let body = {
        folderPath: currentFolderData?.path,
        projectName: activeProject?.name,
      };

      const response = await getStoryList_API(body);
      console.log(response, "response handleGetUserStoryList");

      if (response) {
        errorHandler(response, setIsUserStoryLoading);
      }

      if (response.status === HttpStatusCode.Ok) {
        setUserStoryList(
          response.data?.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
          ),
        );
      }
    } catch (error) {
      console.log(error, error?.message, "projectreponse errorr");
      handleSnackbar(String(error), Severity.error);
    } finally {
      setTimeout(() => {
        setIsUserStoryLoading(false);
      }, 1000);
    }
  };
  const handleActionDialogClose = (success) => {
    setOpenActionDialog(false);
    setSelectedItemsForAction([]);
    setActionDialogType(null);

    // if (success) {
    //   // Refresh the list after successful move/copy
    //   if (pathName === ModulePath.requirements) {
    //     // You need to make sure handleGetUserStoryList is available in this scope
    //     // If not, you may need to pass it as a prop or get it from context
    //   }
    // }
    if (success) {
      setSelectedUserStoryList([]);
      handleGetUserStoryList(); // refresh the list
    }
  };

  const [folderList, setFolderList] = useState([]);
  const [selectedDestinationFolder, setSelectedDestinationFolder] =
    useState(null);

  // delete toolbar button
  const handleToolbarDelete = async (stories) => {
    if (!stories || stories.length === 0) return;

    const validStories = stories.filter((s) =>
      userStoryList.some((u) => u.customId === s.customId),
    );

    if (validStories.length === 0) {
      handleSnackbar("Selected stories are already deleted", "error");
      return;
    }

    const folderMap = {};
    validStories.forEach((s) => {
      if (!folderMap[s.folderPath]) folderMap[s.folderPath] = [];
      folderMap[s.folderPath].push(s.customId);
    });

    try {
      setLoading(true);

      for (const folderPath in folderMap) {
        const body = {
          customIds: folderMap[folderPath],
          folderPath,
          projectName: activeProject?.name,
        };

        const response = await deleteStory_API(body);

        if (response.status === HttpStatusCode.Ok) {
          setUserStoryList((prev) =>
            prev.filter(
              (item) => !folderMap[folderPath].includes(item.customId),
            ),
          );

          setFolderList((prev) =>
            prev.map((f) =>
              f.name === folderPath
                ? { ...f, count: f.count - folderMap[folderPath].length }
                : f,
            ),
          );

          handleSnackbar(response?.data?.message, "success");
        } else {
          errorHandler(response);
        }
      }
    } catch (error) {
      console.error(error, "delete error");
    } finally {
      setLoading(false);
    }
  };

  // --- Copy Handler ---
  const handleToolbarCopy = async (selectedStories, destinationFolder) => {
    if (!selectedStories || selectedStories.length === 0) return;

    const folderMap = {};
    selectedStories.forEach((s) => {
      if (!folderMap[s.folderPath]) folderMap[s.folderPath] = [];
      folderMap[s.folderPath].push(s.customId);
    });

    // Remove duplicates
    for (const folderPath in folderMap) {
      folderMap[folderPath] = [...new Set(folderMap[folderPath])];
    }

    try {
      setLoading(true);

      for (const folderPath in folderMap) {
        const body = {
          section: "userStory",
          folderPath,
          projectName: activeProject?.name,
          operation: "COPY", // enum for backend
          moveToFolderPath: destinationFolder || folderPath,
          customIds: folderMap[folderPath],
        };

        // console.log("Copy payload:", body);

        const response = await moveFolder_API(body);
        if (response.status === HttpStatusCode.Ok) {
          handleSnackbar(
            response?.data?.message || "Copied successfully",
            "success",
          );
        }
      }
    } catch (error) {
      console.error(error, "copy error");
    } finally {
      setLoading(false);
    }
  };

  // --- Move Handler ---
  const handleToolbarMove = async (selectedStories, destinationFolder) => {
    if (!selectedStories || selectedStories.length === 0) return;

    if (!destinationFolder) {
      handleSnackbar("Please select a destination folder", "error");
      return;
    }

    const folderMap = {};
    selectedStories.forEach((s) => {
      if (!folderMap[s.folderPath]) folderMap[s.folderPath] = [];
      folderMap[s.folderPath].push(s.customId);
    });

    // Remove duplicates
    for (const folderPath in folderMap) {
      folderMap[folderPath] = [...new Set(folderMap[folderPath])];
    }

    try {
      setLoading(true);

      for (const folderPath in folderMap) {
        const body = {
          section: "userStory",
          folderPath,
          projectName: activeProject?.name,
          operation: "MOVE", // enum for backend
          moveToFolderPath: destinationFolder,
          customIds: folderMap[folderPath],
        };

        // console.log("Move payload:", body);

        const response = await moveFolder_API(body);
        if (response.status === HttpStatusCode.Ok) {
          setUserStoryList((prev) =>
            prev.filter(
              (item) => !folderMap[folderPath].includes(item.customId),
            ),
          );
          handleSnackbar(
            response?.data?.message || "Moved successfully",
            "success",
          );
        }
      }
    } catch (error) {
      console.error(error, "move error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className="flex flex-col gap-4 w-full h-full overflow-hidden relative">
      {showDisabledOverlay && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backdropFilter: "blur(1px)",
            zIndex: 10,
            pointerEvents: "none",
            borderRadius: theme.shape.borderRadius,
          }}
        />
      )}

      <Box
        className="flex flex-col gap-4"
        sx={{ position: "relative", zIndex: 11 }}
      >
        <Box
          className={`flex items-center justify-between gap-2 h-fit w-full overflow-hidden`}
        >
          <Box className="flex items-center gap-2 w-fit h-fit ">
            <TextField
              type="search"
              variant="outlined"
              placeholder={t("header.searchText")}
              disabled={hasNoData}
              className=""
              sx={{
                minWidth: "100px",
                opacity: hasNoData ? 0.6 : 1,
              }}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="center">
                      <Search sx={{ opacity: hasNoData ? 0.6 : 1 }} />
                    </InputAdornment>
                  ),
                },
              }}
              defaultValue={searchText}
              onChange={(e) => handleChangeSearch(e.target.value)}
            />

            <Box className="flex items-center  ">
              <Button
                variant="outlined"
                startIcon={
                  <FilterAltOutlined sx={{ opacity: hasNoData ? 0.6 : 1 }} />
                }
                onClick={() => setOpenItemFilterDrawer(true)}
                disabled={hasNoData}
                sx={{
                  opacity: hasNoData ? 0.6 : 1,
                  "&.Mui-disabled": {
                    opacity: 0.6,
                  },
                }}
              >
                <Typography
                  className="inline-flex"
                  sx={{ opacity: hasNoData ? 0.6 : 1 }}
                >
                  Filter{" "}
                  {currentFilters && Object.keys(currentFilters).length > 0 && (
                    <Typography>{` [${
                      currentFilters && Object.keys(currentFilters).length
                    }]`}</Typography>
                  )}
                </Typography>
              </Button>
            </Box>
          </Box>

          <Box className=" flex-1 flex items-center justify-end gap-2 overflow-x-auto ">
            <Box className="flex items-center gap-2 overflow-x-auto whitespace-nowrap ">
              {false && (
                <Button
                  variant="outlined"
                  endIcon={<KeyboardArrowDown />}
                  sx={{ minWidth: "fit-content" }}
                  disabled={hasNoData || selectedUserStoryList?.length === 0}
                >
                  More
                </Button>
              )}

              <LightTooltip title={t("header.labelText") || "Label"}>
                <span>
                  <IconButton
                    disabled={hasNoData || selectedUserStoryList?.length === 0}
                    onClick={(e) => setLabelAnchorEl(e.currentTarget)}
                  >
                    <LabelButton
                      selectedList={selectedLabels}
                      anchorEl={labelAnchorEl}
                      open={Boolean(labelAnchorEl)}
                      handleApply={handleApplyLabels}
                      disabled={
                        hasNoData || selectedUserStoryList?.length === 0
                      }
                      handleClose={() => setLabelAnchorEl(null)}
                    />
                  </IconButton>
                </span>
              </LightTooltip>

              <LightTooltip title={t("header.propertiesText") || "Properties"}>
                <span>
                  <IconButton
                    disabled={hasNoData || selectedUserStoryList?.length === 0}
                    onClick={(e) => handleToggleActionMenu(e, "properties")}
                    sx={{ opacity: hasNoData ? 0.6 : 1 }}
                  >
                    <SettingsOutlined />
                  </IconButton>
                </span>
              </LightTooltip>

              <LightTooltip title={t("header.copyText") || "Copy"}>
                <span>
                  <IconButton
                    disabled={
                      hasNoData ||
                      !selectedUserStoryList ||
                      selectedUserStoryList.length === 0
                    }
                    onClick={handleCopyAction}
                    sx={{ opacity: hasNoData ? 0.6 : 1 }}
                  >
                    <FileCopyOutlined />
                  </IconButton>
                </span>
              </LightTooltip>

              <LightTooltip title={t("header.moveText") || "Move"}>
                <span>
                  <IconButton
                    disabled={
                      hasNoData ||
                      !selectedUserStoryList ||
                      selectedUserStoryList.length === 0
                    }
                    onClick={handleMoveAction}
                    sx={{ opacity: hasNoData ? 0.6 : 1 }}
                  >
                    <DriveFileMove />
                  </IconButton>
                </span>
              </LightTooltip>

              <LightTooltip title={t("header.deleteText") || "Delete"}>
                <span>
                  <IconButton
                    disabled={hasNoData || selectedUserStoryList?.length === 0}
                    onClick={() => handleToolbarDelete(selectedUserStoryList)}
                    sx={{ opacity: hasNoData ? 0.6 : 1 }}
                  >
                    <DeleteOutline />
                  </IconButton>
                </span>
              </LightTooltip>

              <LightTooltip title={t("header.uploadText") || "Upload"}>
                <span>
                  <IconButton
                    disabled={hasNoData || selectedUserStoryList?.length === 0}
                    onClick={() => {}}
                    sx={{ opacity: hasNoData ? 0.6 : 1 }}
                  >
                    <FileUploadOutlined />
                  </IconButton>
                </span>
              </LightTooltip>

              <LightTooltip title={t("header.downloadText") || "Download"}>
                <span>
                  <IconButton
                    disabled={hasNoData || selectedUserStoryList?.length === 0}
                    onClick={() => {}}
                    sx={{ opacity: hasNoData ? 0.6 : 1 }}
                  >
                    <FileDownloadOutlined />
                  </IconButton>
                </span>
              </LightTooltip>
            </Box>

            <Box className="h-full flex items-center gap-2 rounded-lg overflow-hidden ">
              <Paper
                elevation={0}
                sx={(theme) => ({
                  display: "flex",
                  border: `1px solid ${theme.palette.divider}`,
                  flexWrap: "wrap",
                  opacity: hasNoData ? 0.6 : 1,
                })}
              >
                <StyledToggleButtonGroup
                  size="small"
                  value={isGridViewEnabled}
                  exclusive
                  disabled={hasNoData}
                  onChange={(e, newValue) => {
                    // console.log(
                    //   newValue,
                    //   isGridViewEnabled,
                    //   newValue !== isGridViewEnabled,
                    //   "value togglebutton"
                    // );
                    if (newValue !== null) {
                      setIsGridViewEnabled(newValue);
                    }
                  }}
                  aria-label="text alignment"
                  sx={{
                    boxSizing: "border-box",
                    "&.Mui-disabled": {
                      opacity: 0.6,
                    },
                  }}
                >
                  <StyledToggleButton
                    value={true}
                    aria-label="centered"
                    disabled={hasNoData}
                  >
                    <LightTooltip title={t("header.gridText")}>
                      <GridViewTwoToneIcon />
                    </LightTooltip>
                  </StyledToggleButton>

                  <StyledToggleButton
                    value={false}
                    aria-label="centered"
                    disabled={hasNoData}
                  >
                    <LightTooltip title={t("header.listText")}>
                      <ListTwoToneIcon />
                    </LightTooltip>
                  </StyledToggleButton>
                </StyledToggleButtonGroup>
              </Paper>
            </Box>
          </Box>
        </Box>

        {currentFilters && Object.keys(currentFilters)?.length > 0 && (
          <Box className=" h-fit w-full flex  overflow-x-auto ">
            <Box
              className={` h-fit w-full flex items-center gap-2 overflow-x-auto `}
            >
              {currentFilters &&
                Object.keys(currentFilters)?.map((key, index) => {
                  return (
                    <Box
                      className="flex flex-col items-center px-1 pb-1"
                      bgcolor={theme.palette.background.paper}
                      borderRadius={theme.shape.borderRadius}
                    >
                      <Typography
                        fontSize={font.size.fs_6}
                        className="flex capitalize"
                      >
                        {key}
                      </Typography>
                      <Box className="flex items-center gap-1">
                        {Array.isArray(currentFilters[key])
                          ? currentFilters[key]?.map((itemValue, index) => (
                              <Box
                                key={index}
                                className="flex items-center gap-1 px-1 border"
                                bgcolor={theme.palette.background.custom}
                                borderRadius={theme.shape.borderRadius}
                              >
                                <Typography
                                  fontSize={font.size.fs_6}
                                  lineHeight={font.size.fs_6}
                                >
                                  {itemValue}
                                </Typography>
                                <Close
                                  sx={{
                                    fontSize: font.size.fs_5,
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handleRemoveFilterItem(key, itemValue)
                                  }
                                />
                              </Box>
                            ))
                          : Object.keys(currentFilters[key])?.map(
                              (ObjectKey, index) => {
                                // console.log(
                                //   dayjs(currentFilters[key][ObjectKey]).format(
                                //     "DD-MM-YYYY"
                                //   ),
                                //   "currentFilters[key][ObjectKey]"
                                // );
                                return (
                                  <Box
                                    key={index}
                                    className="flex items-center gap-1 px-1 border"
                                    bgcolor={theme.palette.background.custom}
                                    borderRadius={theme.shape.borderRadius}
                                  >
                                    <Typography
                                      fontSize={font.size.fs_6}
                                      lineHeight={font.size.fs_6}
                                      className="whitespace-nowrap"
                                    >
                                      {dayjs(
                                        currentFilters[key][ObjectKey],
                                      ).format("DD-MM-YYYY")}
                                    </Typography>
                                    <Close
                                      sx={{
                                        fontSize: font.size.fs_5,
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        handleRemoveFilterItem(
                                          ObjectKey,
                                          currentFilters[key][ObjectKey],
                                        )
                                      }
                                    />
                                  </Box>
                                );
                              },
                            )}
                      </Box>
                    </Box>
                  );
                })}
            </Box>
          </Box>
        )}
      </Box>

      {/* list container */}
      <Box
        className={`flex w-full  ${
          isGridViewEnabled ? "h-full" : "h-full"
        } overflow-y-auto `}
        sx={{ position: "relative", zIndex: 11 }}
      >
        {isLoading || isUserStoryLoading ? (
          <Box
            className={`grow flex flex-col gap-2 items-center justify-center `}
            border={`1px solid ${theme.palette.divider}`}
            bgcolor={theme.palette.background.paper}
            borderRadius={theme.shape.borderRadius}
          >
            <Typography fontSize={font.size.fs_5}>Loading...</Typography>
          </Box>
        ) : finalList?.length === 0 ? (
          <Box
            className="grow flex flex-col gap-2 justify-center items-center"
            border={`1px solid ${theme.palette.divider}`}
            bgcolor={theme.palette.background.paper}
            borderRadius={theme.shape.borderRadius}
          >
            {/* <UserStoryCustomIcon
              sx={{ fontSize: font.size.fs_2, opacity: 0.6 }}
            />
            <Typography fontSize={font.size.fs_5} color="textSecondary">
              {t("addText")} {Entity_Label.userStory}
            </Typography> */}
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              minHeight={400}
              gap={2}
              sx={{ mt: 4 }}
            >
              <UserStoryCustomIcon
                sx={{
                  fontSize: 80,
                  color: (theme) => theme.palette.text.secondary,
                  opacity: 0.7,
                }}
              />
              <Typography variant="h5" color="text.secondary" fontWeight={500}>
                No user story found
              </Typography>
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ opacity: 0.8 }}
              >
                Create your first story to get started
              </Typography>
              <Button
                startIcon={<Add />}
                disabled={!currentFolderData}
                onClick={() => setOpenCreateStoryDialog(true)}
                sx={{
                  mt: 2,
                  borderRadius: "10px",
                  textTransform: "none",
                  fontWeight: 600,
                  height: 40,
                  px: 3,
                  background: !currentFolderData
                    ? theme.palette.action.disabledBackground
                    : "linear-gradient(90deg, hsl(var(--cyan)), hsl(var(--emerald)))",
                  color: "hsl(var(--primary-foreground))",
                  boxShadow: "0 4px 14px hsl(var(--cyan) / 0.35)",
                  "&:hover": {
                    background:
                      "linear-gradient(90deg, hsl(var(--cyan) / 0.9), hsl(var(--emerald) / 0.9))",
                    boxShadow: "0 6px 20px hsl(var(--cyan) / 0.45)",
                  },
                  "&:active": {
                    transform: "scale(0.98)",
                  },
                }}
              >
                Create New User Story
              </Button>
            </Box>
          </Box>
        ) : (
          <Box className={`flex w-full`}>
            {isGridViewEnabled ? (
              <Suspense fallback={<FallbackUILoader />}>
                <UserStoryGrid
                  dataList={finalList}
                  isLoading={isUserStoryLoading}
                />
              </Suspense>
            ) : (
              <Suspense fallback={<FallbackUILoader />}>
                <UserStoryList
                  dataList={finalList}
                  isLoading={isUserStoryLoading}
                />
              </Suspense>
            )}
          </Box>
        )}
      </Box>

      <Menu
        open={Boolean(actionIconAnchorEl)}
        anchorEl={actionIconAnchorEl}
        onClose={(e) => handleToggleActionMenu(e, null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box>
          <Box className="flex items-center px-4 py-2 border-b">
            <Typography
              color={theme.palette.text.primary}
              fontSize={font.size.fs_4}
            >
              Properties
            </Typography>
          </Box>

          {actionType === "properties" && (
            <Box className="flex gap-0 divide-x">
              {userStoryPropertiesData &&
                Object.keys(userStoryPropertiesData).map((key) => (
                  <Box key={key} className="flex flex-col">
                    <Typography
                      fontSize={font.size.fs_5}
                      color={theme.palette.text.primary}
                      className="px-4 py-1 capitalize border-b"
                    >
                      {key}
                    </Typography>
                    <Box className="w-full h-full flex flex-col ">
                      {userStoryPropertiesData[key]?.map((item, index) => (
                        <MenuItem
                          key={index}
                          selected={
                            selectedPropertiesData &&
                            key in selectedPropertiesData &&
                            selectedPropertiesData[key] &&
                            selectedPropertiesData[key] === item?.key
                          }
                          onClick={() => {
                            handleSelectProperites(key, item?.key);
                          }}
                        >
                          <Typography
                            fontSize={font.size.fs_5}
                            color={theme.palette.text.secondary}
                            className=""
                          >
                            {item?.value}
                          </Typography>
                        </MenuItem>
                      ))}
                    </Box>
                  </Box>
                ))}
            </Box>
          )}

          <Box className="flex items-center justify-end px-4 py-2 border-t">
            <Button
              variant="text"
              onClick={(e) => handleCancelPropertiesData()}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="secondary"
              disabled={isLoading}
              sx={{ color: theme.palette.secondary.contrastText }}
              onClick={handleApplyPropertiesData}
            >
              Apply
            </Button>
          </Box>
        </Box>
      </Menu>

      <Menu
        open={Boolean(moreAnchorEl)}
        anchorEl={moreAnchorEl}
        onClose={handleToggleMoreMenu}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box>
          <Box className="flex items-center px-4 py-2 border-b">
            <Typography
              color={theme.palette.text.primary}
              fontSize={font.size.fs_4}
            >
              Actions
            </Typography>
          </Box>

          <MenuItem
            onClick={(e) => handleToggleActionMenu(e, "label")}
            disabled={selectedUserStoryList?.length === 0}
          >
            <ListItemIcon>
              <LabelOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t("header.labelText")}</ListItemText>
          </MenuItem>

          <MenuItem
            onClick={(e) => handleToggleActionMenu(e, "properties")}
            disabled={selectedUserStoryList?.length === 0}
          >
            <ListItemIcon>
              <FilterAltOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t("header.propertiesText")}</ListItemText>
          </MenuItem>

          <MenuItem disabled={true || selectedUserStoryList?.length === 0}>
            <ListItemIcon>
              <FileCopyOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t("header.copyText")}</ListItemText>
          </MenuItem>

          <MenuItem disabled={true || selectedUserStoryList?.length === 0}>
            <ListItemIcon>
              <DriveFileMove fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t("header.moveText")}</ListItemText>
          </MenuItem>

          <MenuItem
            onClick={handleDeleteClick}
            disabled={selectedUserStoryList?.length === 0}
          >
            <ListItemIcon>
              <DeleteOutline fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t("header.deleteText")}</ListItemText>
          </MenuItem>

          <MenuItem disabled={true || selectedUserStoryList?.length === 0}>
            <ListItemIcon>
              <FileUploadOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t("header.uploadText")}</ListItemText>
          </MenuItem>

          <MenuItem disabled={true || selectedUserStoryList?.length === 0}>
            <ListItemIcon>
              <FileDownloadOutlined fontSize="small" />
            </ListItemIcon>
            <ListItemText>{t("header.downloadText")}</ListItemText>
          </MenuItem>
        </Box>
      </Menu>

      <Suspense fallback={<FallbackUILoader />}>
        {openItemFilterDrawer && (
          <FilterItemDrawer
            open={openItemFilterDrawer}
            onClose={() => {
              // console.log("Closing filter drawer from main component");
              setOpenItemFilterDrawer(false);
            }}
          />
        )}
      </Suspense>

      {/* ADD THE MOVECOPY DIALOG HERE - AT THE VERY END */}
      <Suspense fallback={<FallbackUILoader />}>
        {openActionDialog && (
          <MoveCopyDialog
            open={openActionDialog}
            onClose={handleActionDialogClose}
            items={selectedItemsForAction}
            currentFolderPath={currentFolderData?.path || ""}
            projectName={activeProject?.name}
            section="requirements"
            operation={actionDialogType}
          />
        )}
      </Suspense>
    </Box> // This is the closing Box of the component
  );
}

function UseCaseContainerComponent() {
  const {
    isGridViewEnabled,
    setIsGridViewEnabled,
    handleSnackbar,
    currentFolderData,
    setCurrentFolderData,
    useCaseList,
    setUseCaseList,
    currentUseCaseData,
    setCurrentUseCaseData,
    filteredUseCaseList,
    setFilteredUseCaseList,
    isActiveProjectContainerLoading,
    setIsActiveProjectContainerLoading,
    selectedUseCaseList,
    setSelectedUseCaseList,
    setOpenDeleteUseCaseDialog,
    currentFilters,
    setCurrentFilters,
    openItemFilterDrawer,
    setOpenItemFilterDrawer,
    useCasePropertiesData,
    setUseCasePropertiesData,
    activeProject,
  } = useApplicationContext();

  const {
    labelList,
    setLabelList,
    selectedLabels,
    setSelectedLabels,
    labelAnchorEl,
    setLabelAnchorEl,
    searchText,
    setSearchText,
    loading,
    setLoading,
    openLabelDialog,
    setOpenLabelDialog,
    isLabelEditMode,
    setIsLabelEditMode,
    currentLabelData,
    setCurrentLabelData,
    labelData,
    setLabelData,
    handleToggleLabelPopup,
    handleChangeLabel,
    handleOpenLabelAddUpdate_Dialog,
    handleLabelUpdate,
    handleAddLabel,
    handleCloseDialog,
    handleClickLabelButton,
    handleGetList,
    openDeleteStoryDialog,
    setOpenCreateUseCaseDialog,
  } = useApplicationContext();

  const theme = useTheme();
  const errorHandler = useErrorHandler();
  const pathName = useLocation().pathname;
  const { t } = useTranslation("translation", { keyPrefix: "activeProject" });

  const isTabletScreen = useMediaQuery((theme) => theme.breakpoints.down("xl"));

  const [isLoading, setIsLoading] = useState(false);
  const [isShowFilters, setIsShowFilters] = useState(true);
  const [actionType, setActionType] = useState("label");
  const [actionIconAnchorEl, setActionIconAnchorEl] = useState(null);

  const [finalList, setFinalList] = useState(filteredUseCaseList);
  const [selectedPropertiesData, setSelectedPropertiesData] = useState(null);

  const [priorityList, setPriorityList] = useState([]);
  const [typeList, setTypeList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [statusList, setStatusList] = useState([]);

  // ADD THESE STATE VARIABLES HERE
  const [openActionDialog, setOpenActionDialog] = useState(false);
  const [actionDialogType, setActionDialogType] = useState(null); // 'copy' or 'move'
  const [selectedItemsForAction, setSelectedItemsForAction] = useState([]);

  const MoveCopyDialog = lazy(() => import("../../dialog/MoveCopyDialog"));

  const [activeFilterData, setActiveFilterData] = useState({
    status: "all",
  });

  const hasNoData = useCaseList?.length === 0;
  const showDisabledOverlay = hasNoData;

  const handleChangeSearch = debounce((value) => {
    setSearchText(value);
  }, 300);

  const handleDeleteClick = () => {
    setOpenDeleteUseCaseDialog(true);
    console.log(openDeleteStoryDialog, "true");
  };

  const handleChangeFilter = (e) => {
    setActiveFilterData({
      ...activeFilterData,
      [e.target.name]: e.target.value,
    });
  };

  const handleToggleActionMenu = (event, actionType) => {
    if (!actionIconAnchorEl) {
      setActionIconAnchorEl(event.currentTarget);
      setActionType(actionType);
    } else {
      setActionIconAnchorEl(null);
    }
  };

  const handleRemoveFilterItem = (key, value) => {
    let filter = currentFilters ? { ...currentFilters } : {};

    if (Array.isArray(filter[key])) {
      filter[key] = currentFilters[key].filter((item) => item !== value);
      if (filter[key].length === 0) {
        delete filter[key];
      }
    } else {
      if (key === "from") {
        delete filter["createdAt"][key];
      }

      if (key === "to") {
        delete filter["createdAt"][key];
      }

      if (
        filter["createdAt"] &&
        Object.keys(filter["createdAt"])?.length === 0
      ) {
        delete filter["createdAt"];
      } else {
        delete filter[key];
      }
    }

    if (filter && Object.keys(filter)?.length === 0) {
      setCurrentFilters(null);
      return;
    }

    setCurrentFilters(filter);
  };

  const handleGetFilterCount = (value) => {
    if (value === Filters.status) {
      return currentFilters?.status?.length;
    }

    if (value === Filters.createdAt) {
      return currentFilters?.createdAt?.from && currentFilters?.createdAt?.to
        ? 2
        : currentFilters?.createdAt?.from
          ? 1
          : currentFilters?.createdAt?.to
            ? 1
            : 0;
    }
  };

  const handleChangeColumnFilter = (event, key) => {
    const filterData = currentFilters ? { ...currentFilters } : {};

    if (event.target.value === "") {
      delete filterData[key];
    } else {
      filterData[key] = event.target.value;
    }

    setCurrentFilters(filterData);
  };

  const handleSelectProperites = (key, value) => {
    setSelectedPropertiesData({ ...selectedPropertiesData, [key]: value });
  };

  const handleCancelPropertiesData = () => {
    setSelectedPropertiesData(null);
    setActionIconAnchorEl(null);
  };

  const handleApplyPropertiesData = () => {
    console.log(currentFolderData, selectedUseCaseList, "apapapapapaap");
    let body = {
      customIds: [selectedUseCaseList?.map((item) => item?.customId)],
      lastModifiedAt: selectedUseCaseList[0].lastModifiedAt,
      folderPath: currentFolderData?.path,
      projectName: activeProject?.name,
    };

    body = { ...body, ...selectedPropertiesData };

    handleUpdateStory(body);
  };

  const handleUpdateStory = async (storyData) => {
    try {
      setIsActiveProjectContainerLoading(true);

      let body = {
        ...storyData,
      };

      const bodyFormData = new FormData();
      Object.keys(body).forEach((key) => {
        if (Array.isArray(body[key])) {
          bodyFormData.append(key, body[key]);
        } else {
          bodyFormData.append(key, body[key]);
        }
      });

      const response = await updateUseCase_API(bodyFormData);
      console.log(response, "response handleUpdateStory");

      if (response) {
        errorHandler(response, setIsActiveProjectContainerLoading);
      }

      if (response?.status === HttpStatusCode.Ok) {
        let updatedList = response.data;

        updatedList?.forEach((item) => {
          let list = useCaseList;
          let foundIndex = list?.findIndex(
            (listItem) => listItem?.customId === item?.customId,
          );
          if (foundIndex !== -1) {
            list[foundIndex] = item;
          }
          setUseCaseList(
            list?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)),
          );
        });

        setSelectedUseCaseList([]);
        setActionIconAnchorEl(null);

        setTimeout(() => {
          handleSnackbar("UseCase updated successfully", Severity.success);
        }, 500);
      }

      console.log(response, "projectreponse data");
    } catch (error) {
      console.log(error, error?.message, "projectreponse errorr");
      handleSnackbar(String(error), Severity.error);
    } finally {
      setTimeout(() => {
        setIsActiveProjectContainerLoading(false);
      }, 1000);
    }
  };

  useEffect(() => {
    let list = filteredUseCaseList;

    if (searchText) {
      list = list?.filter(
        (item) =>
          item?.customId?.toLowerCase()?.includes(searchText.toLowerCase()) ||
          item?.title?.toLowerCase()?.includes(searchText.toLowerCase()) ||
          item?.state?.toLowerCase()?.includes(searchText.toLowerCase()) ||
          item?.status?.toLowerCase()?.includes(searchText.toLowerCase()) ||
          item?.priority?.toLowerCase()?.includes(searchText.toLowerCase()) ||
          item?.type?.toLowerCase()?.includes(searchText.toLowerCase()),
      );
    }

    setFinalList(list);
  }, [searchText, filteredUseCaseList, setFinalList]);

  useEffect(() => {
    setIsLoading(isActiveProjectContainerLoading);
  }, [isActiveProjectContainerLoading, setIsActiveProjectContainerLoading]);

  useEffect(() => {
    setIsLoading(true);
    if (currentFilters) {
      const filteredRows = useCaseList?.filter((row) =>
        Object.entries(currentFilters).every(([column, value]) => {
          console.log(column, value, row, "column, value, row");
          if (!value) return true;
          if (Array.isArray(value)) {
            return value.includes(row[column]?.toString());
          } else {
            if (column === "createdAt") {
              if (value.from && value.to) {
                return (
                  dayjs(row["createdAt"]).isAfter(dayjs(value.from), "day") &&
                  dayjs(row["createdAt"]).isBefore(dayjs(value.to), "day")
                );
              } else if (value.from) {
                return (
                  dayjs(row["createdAt"]).isAfter(dayjs(value.from), "day") ||
                  dayjs(row["createdAt"]).isSame(dayjs(value.from), "day")
                );
              } else if (value.to) {
                return (
                  dayjs(row["createdAt"]).isBefore(dayjs(value.to), "day") ||
                  dayjs(row["createdAt"]).isSame(dayjs(value.to), "day")
                );
              } else {
                return false;
              }
            } else {
              return row[column]
                ?.toString()
                .toLowerCase()
                .includes(value.toLowerCase());
            }
          }
        }),
      );
      setFilteredUseCaseList(filteredRows);
      console.log(filteredRows, "filteredRows");
    } else {
      setFilteredUseCaseList(useCaseList);
    }

    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, [currentFilters, useCaseList, setFilteredUseCaseList]);

  useEffect(() => {
    setFilteredUseCaseList(useCaseList);
  }, [useCaseList, setFilteredUseCaseList]);

  useEffect(() => {
    if (useCasePropertiesData) {
      setTypeList(useCasePropertiesData["type"]);
      setStateList(useCasePropertiesData["state"]);
      setStatusList(useCasePropertiesData["status"]);
      setPriorityList(useCasePropertiesData["priority"]);
    }
  }, [useCasePropertiesData]);

  console.log(isTabletScreen, "isTabletScreen");

  const handleApplyLabels = async (labels) => {
    if (!selectedUseCaseList || selectedUseCaseList.length === 0) return;

    try {
      setLoading(true);

      for (const useCase of selectedUseCaseList) {
        const payload = {
          customIds: [useCase?.customId],
          lastModifiedAt: useCase?.lastModifiedAt,
          folderPath: useCase?.folderPath,
          projectName: activeProject?.name,
          labels: labels.map((l) => l.name).join(","),
        };

        const formData = new FormData();
        Object.keys(payload).forEach((key) => {
          if (Array.isArray(payload[key])) {
            formData.append(key, payload[key].join(","));
          } else {
            formData.append(key, payload[key]);
          }
        });

        await updateUseCase_API(formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        const index = useCaseList.findIndex(
          (item) => item.customId === useCase.customId,
        );
        if (index !== -1) {
          const updatedUseCase = {
            ...useCase,
            labels: labels.map((l) => ({
              name: l.name,
              colorCode: l.colorCode,
            })),
          };
          const newList = [...useCaseList];
          newList[index] = updatedUseCase;
          setUseCaseList(newList);
        }
      }

      handleSnackbar("Labels updated successfully", Severity.success);
      setLabelAnchorEl(null);
    } catch (err) {
      console.error(err);
      handleSnackbar(err.message, Severity.error);
    } finally {
      setLoading(false);
    }
  };

  const handleMoveAction = () => {
    const items = selectedUseCaseList;
    if (!items || items.length === 0) {
      handleSnackbar("Please select items to move", "warning");
      return;
    }
    setSelectedItemsForAction(items);
    setActionDialogType("move");
    setOpenActionDialog(true);
  };

  const handleCopyAction = () => {
    const items = selectedUseCaseList;
    if (!items || items.length === 0) {
      handleSnackbar("Please select items to copy", "warning");
      return;
    }
    setSelectedItemsForAction(items);
    setActionDialogType("copy");
    setOpenActionDialog(true);
  };

  const handleActionDialogClose = (success) => {
    setOpenActionDialog(false);
    setSelectedItemsForAction([]);
    setActionDialogType(null);

    if (success) {
      setSelectedUseCaseList([]);
      if (pathName === ModulePath.useCase) {
        // Refresh logic here
      }
    }
  };

  const [useCaseFolderList, setUseCaseFolderList] = useState([]);

  const handleUseCaseDelete = async (selectedUseCases) => {
    if (!selectedUseCases || selectedUseCases.length === 0) return;

    const validUseCases = selectedUseCases.filter((u) =>
      useCaseList.some((item) => item.customId === u.customId),
    );

    if (validUseCases.length === 0) {
      handleSnackbar("Selected use cases are already deleted", "error");
      return;
    }

    const folderMap = {};
    validUseCases.forEach((u) => {
      if (!folderMap[u.folderPath]) folderMap[u.folderPath] = [];
      folderMap[u.folderPath].push(u.customId);
    });

    try {
      setLoading(true);

      for (const folderPath in folderMap) {
        const body = {
          customIds: folderMap[folderPath],
          folderPath,
          projectName: activeProject?.name,
        };

        const response = await deleteUseCase_API(body);

        if (response.status === HttpStatusCode.Ok) {
          setUseCaseList((prev) =>
            prev.filter(
              (item) => !folderMap[folderPath].includes(item.customId),
            ),
          );

          setUseCaseFolderList((prev) =>
            prev.map((f) =>
              f.name === folderPath
                ? { ...f, count: f.count - folderMap[folderPath].length }
                : f,
            ),
          );

          handleSnackbar(response?.data?.message, "success");
        } else {
          errorHandler(response);
        }
      }
    } catch (error) {
      console.error(error, "use case delete error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className="flex flex-col gap-4 w-full h-full overflow-hidden relative">
      {/* {showDisabledOverlay && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
           
            backdropFilter: "blur(2px)",
            zIndex: 10,
            pointerEvents: "none",
            borderRadius: theme.shape.borderRadius,
          }}
        />
      )} */}

      <Box
        className="flex flex-col gap-4"
        sx={{ position: "relative", zIndex: 11 }}
      >
        <Box
          className={`flex items-center justify-between gap-2 h-fit w-full overflow-hidden`}
        >
          <Box className="flex items-center gap-2 w-fit h-fit">
            <TextField
              type="search"
              variant="outlined"
              placeholder={t("header.searchText")}
              disabled={hasNoData}
              className=""
              sx={{
                minWidth: "100px",
                opacity: hasNoData ? 0.6 : 1,
              }}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="center">
                      <Search sx={{ opacity: hasNoData ? 0.6 : 1 }} />
                    </InputAdornment>
                  ),
                },
              }}
              defaultValue={searchText}
              onChange={(e) => handleChangeSearch(e.target.value)}
            />

            <Box className="flex items-center ">
              <Button
                variant="outlined"
                startIcon={
                  <FilterAltOutlined sx={{ opacity: hasNoData ? 0.6 : 1 }} />
                }
                onClick={() => setOpenItemFilterDrawer(true)}
                disabled={hasNoData}
                sx={{
                  opacity: hasNoData ? 0.6 : 1,
                  "&.Mui-disabled": {
                    opacity: 0.6,
                  },
                }}
              >
                <Typography
                  className="inline-flex"
                  sx={{ opacity: hasNoData ? 0.6 : 1 }}
                >
                  Filter{" "}
                  {currentFilters && Object.keys(currentFilters).length > 0 && (
                    <Typography>{` [${
                      currentFilters && Object.keys(currentFilters).length
                    }]`}</Typography>
                  )}
                </Typography>
              </Button>
            </Box>
          </Box>

          <Box className="  flex-1 flex items-center justify-end gap-2 overflow-hidden  ">
            <Box className="flex items-center justify-end gap-2  overflow-x-auto ">
              <LightTooltip title={t("header.labelText") || "Label"}>
                <span>
                  <IconButton
                    disabled={hasNoData || selectedUseCaseList?.length === 0}
                    onClick={(e) => setLabelAnchorEl(e.currentTarget)}
                    sx={{ opacity: hasNoData ? 0.6 : 1 }}
                  >
                    <LabelButton
                      selectedList={selectedLabels}
                      anchorEl={labelAnchorEl}
                      open={Boolean(labelAnchorEl)}
                      handleApply={handleApplyLabels}
                      disabled={hasNoData || selectedUseCaseList?.length === 0}
                      handleClose={() => setLabelAnchorEl(null)}
                    />
                  </IconButton>
                </span>
              </LightTooltip>

              <LightTooltip title={t("header.propertiesText") || "Properties"}>
                <span>
                  <IconButton
                    disabled={hasNoData || selectedUseCaseList?.length === 0}
                    onClick={(e) => handleToggleActionMenu(e, "properties")}
                    sx={{ opacity: hasNoData ? 0.6 : 1 }}
                  >
                    <SettingsOutlined />
                  </IconButton>
                </span>
              </LightTooltip>

              <LightTooltip title={t("header.copyText") || "Copy"}>
                <span>
                  <IconButton
                    disabled={
                      hasNoData ||
                      !selectedUseCaseList ||
                      selectedUseCaseList.length === 0
                    }
                    onClick={handleCopyAction}
                    sx={{ opacity: hasNoData ? 0.6 : 1 }}
                  >
                    <FileCopyOutlined />
                  </IconButton>
                </span>
              </LightTooltip>

              <LightTooltip title={t("header.moveText") || "Move"}>
                <span>
                  <IconButton
                    disabled={
                      hasNoData ||
                      !selectedUseCaseList ||
                      selectedUseCaseList.length === 0
                    }
                    onClick={handleMoveAction}
                    sx={{ opacity: hasNoData ? 0.6 : 1 }}
                  >
                    <DriveFileMove />
                  </IconButton>
                </span>
              </LightTooltip>

              <LightTooltip title={t("header.deleteText") || "Delete"}>
                <span>
                  <IconButton
                    disabled={hasNoData || selectedUseCaseList?.length === 0}
                    onClick={() => handleUseCaseDelete(selectedUseCaseList)}
                    sx={{ opacity: hasNoData ? 0.6 : 1 }}
                  >
                    <DeleteOutline />
                  </IconButton>
                </span>
              </LightTooltip>

              <LightTooltip title={t("header.uploadText") || "Upload"}>
                <span>
                  <IconButton
                    disabled={
                      hasNoData || true || selectedUseCaseList?.length === 0
                    }
                    onClick={() => {}}
                    sx={{ opacity: hasNoData ? 0.6 : 1 }}
                  >
                    <FileUploadOutlined />
                  </IconButton>
                </span>
              </LightTooltip>

              <LightTooltip title={t("header.downloadText") || "Download"}>
                <span>
                  <IconButton
                    disabled={
                      hasNoData || true || selectedUseCaseList?.length === 0
                    }
                    onClick={() => {}}
                    sx={{ opacity: hasNoData ? 0.6 : 1 }}
                  >
                    <FileDownloadOutlined />
                  </IconButton>
                </span>
              </LightTooltip>
            </Box>

            <Box className=" h-full flex items-center  gap-2  rounded-lg overflow-hidden ">
              <Paper
                elevation={0}
                sx={(theme) => ({
                  display: "flex",
                  border: `1px solid ${theme.palette.divider}`,
                  flexWrap: "wrap",
                  opacity: hasNoData ? 0.6 : 1,
                })}
              >
                <StyledToggleButtonGroup
                  size="small"
                  value={isGridViewEnabled}
                  exclusive
                  disabled={hasNoData}
                  onChange={(e, newValue) => {
                    console.log(
                      newValue,
                      isGridViewEnabled,
                      newValue !== isGridViewEnabled,
                      "value togglebutton",
                    );
                    if (newValue !== null) {
                      setIsGridViewEnabled(newValue);
                    }
                  }}
                  aria-label="text alignment"
                  sx={{
                    boxSizing: "border-box",
                    "&.Mui-disabled": {
                      opacity: 0.6,
                    },
                  }}
                >
                  <StyledToggleButton
                    value={true}
                    aria-label="centered"
                    disabled={hasNoData}
                  >
                    <LightTooltip title={t("header.gridText")}>
                      <GridViewTwoToneIcon />
                    </LightTooltip>
                  </StyledToggleButton>

                  <StyledToggleButton
                    value={false}
                    aria-label="centered"
                    disabled={hasNoData}
                  >
                    <LightTooltip title={t("header.listText")}>
                      <ListTwoToneIcon />
                    </LightTooltip>
                  </StyledToggleButton>
                </StyledToggleButtonGroup>
              </Paper>
            </Box>
          </Box>
        </Box>

        {currentFilters && Object.keys(currentFilters)?.length > 0 && (
          <Box className=" h-fit w-full flex  overflow-x-auto ">
            <Box
              className={` h-fit w-full flex items-center gap-2 overflow-x-auto `}
            >
              {currentFilters &&
                Object.keys(currentFilters)?.map((key, index) => {
                  return (
                    <Box
                      className="flex flex-col items-center px-1 pb-1"
                      bgcolor={theme.palette.background.paper}
                      borderRadius={theme.shape.borderRadius}
                    >
                      <Typography
                        fontSize={font.size.fs_6}
                        className="flex capitalize"
                      >
                        {key}
                      </Typography>
                      <Box className="flex items-center gap-1">
                        {Array.isArray(currentFilters[key])
                          ? currentFilters[key]?.map((itemValue, index) => (
                              <Box
                                key={index}
                                className="flex items-center gap-1 px-1 border"
                                bgcolor={theme.palette.background.custom}
                                borderRadius={theme.shape.borderRadius}
                              >
                                <Typography
                                  fontSize={font.size.fs_6}
                                  lineHeight={font.size.fs_6}
                                >
                                  {itemValue}
                                </Typography>
                                <Close
                                  sx={{
                                    fontSize: font.size.fs_5,
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handleRemoveFilterItem(key, itemValue)
                                  }
                                />
                              </Box>
                            ))
                          : Object.keys(currentFilters[key])?.map(
                              (ObjectKey, index) => {
                                console.log(
                                  dayjs(currentFilters[key][ObjectKey]).format(
                                    "DD-MM-YYYY",
                                  ),
                                  "currentFilters[key][ObjectKey]",
                                );
                                return (
                                  <Box
                                    key={index}
                                    className="flex items-center gap-1 px-1 border"
                                    bgcolor={theme.palette.background.custom}
                                    borderRadius={theme.shape.borderRadius}
                                  >
                                    <Typography
                                      fontSize={font.size.fs_6}
                                      lineHeight={font.size.fs_6}
                                      className="whitespace-nowrap"
                                    >
                                      {dayjs(
                                        currentFilters[key][ObjectKey],
                                      ).format("DD-MM-YYYY")}
                                    </Typography>
                                    <Close
                                      sx={{
                                        fontSize: font.size.fs_5,
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        handleRemoveFilterItem(
                                          ObjectKey,
                                          currentFilters[key][ObjectKey],
                                        )
                                      }
                                    />
                                  </Box>
                                );
                              },
                            )}
                      </Box>
                    </Box>
                  );
                })}
            </Box>
          </Box>
        )}

        <Popover
          open={Boolean(actionIconAnchorEl)}
          anchorEl={actionIconAnchorEl}
          onClose={(e) => handleToggleActionMenu(e, null)}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <Box>
            {actionType === "label" &&
              ["red", "blue", "green", "grey", "brown"].map((item, index) => {
                return (
                  <MenuItem>
                    <LabelOutlined sx={{ color: item }} />
                  </MenuItem>
                );
              })}

            <Box className="flex items-center px-4 py-2 border-b">
              <Typography
                color={theme.palette.text.primary}
                fontSize={font.size.fs_4}
              >
                Properties
              </Typography>
            </Box>

            {actionType === "properties" && (
              <Box className="flex gap-0 divide-x">
                {useCasePropertiesData &&
                  Object.keys(useCasePropertiesData).map((key) => (
                    <Box key={key} className="flex flex-col">
                      <Typography
                        fontSize={font.size.fs_5}
                        color={theme.palette.text.primary}
                        className="px-4 py-1 capitalize border-b"
                      >
                        {key}
                      </Typography>
                      <Box className="w-full h-full flex flex-col ">
                        {useCasePropertiesData[key]?.map((item, index) => (
                          <MenuItem
                            key={index}
                            selected={
                              selectedPropertiesData &&
                              key in selectedPropertiesData &&
                              selectedPropertiesData[key] &&
                              selectedPropertiesData[key] === item?.key
                            }
                            onClick={() => {
                              handleSelectProperites(key, item?.key);
                            }}
                          >
                            <Typography
                              fontSize={font.size.fs_5}
                              color={theme.palette.text.secondary}
                              className=""
                            >
                              {item?.value}
                            </Typography>
                          </MenuItem>
                        ))}
                      </Box>
                    </Box>
                  ))}
              </Box>
            )}

            <Box className="flex items-center justify-end px-4 py-2 border-t">
              <Button
                variant="text"
                onClick={(e) => handleCancelPropertiesData()}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="secondary"
                sx={{ color: theme.palette.secondary.contrastText }}
                onClick={handleApplyPropertiesData}
              >
                Apply
              </Button>
            </Box>
          </Box>
        </Popover>
      </Box>

      {/* list container */}
      <Box
        className={`flex w-full  ${
          isGridViewEnabled ? "h-full" : "h-full"
        } overflow-y-auto `}
        sx={{ position: "relative", zIndex: 11 }}
      >
        {isLoading || isActiveProjectContainerLoading ? (
          <Box
            className={`grow flex flex-col gap-2 items-center justify-center `}
            border={`1px solid ${theme.palette.divider}`}
            bgcolor={theme.palette.background.paper}
            borderRadius={theme.shape.borderRadius}
          >
            <Typography fontSize={font.size.fs_5}>Loading...</Typography>
          </Box>
        ) : finalList?.length === 0 ? (
          <Box
            className="grow flex flex-col gap-2 justify-center items-center "
            border={`1px solid ${theme.palette.divider}`}
            bgcolor={theme.palette.background.paper}
            borderRadius={theme.shape.borderRadius}
          >
            {/* <UseCaseCustomIcon
              sx={{ fontSize: font.size.fs_2, opacity: 0.6 }}
            />
            <Typography fontSize={font.size.fs_5} color="textSecondary">
              {t("addText")} {Entity_Label.useCase}
            </Typography> */}
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              minHeight={400}
              gap={2}
              sx={{ mt: 4 }}
            >
              <UserStoryCustomIcon
                sx={{
                  fontSize: 80,
                  color: (theme) => theme.palette.text.secondary,
                  opacity: 0.7,
                }}
              />
              <Typography variant="h5" color="text.secondary" fontWeight={500}>
                No use case found
              </Typography>
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ opacity: 0.8 }}
              >
                Create your first use case to get started
              </Typography>
              <Button
                startIcon={<Add />}
                disabled={!currentFolderData}
                onClick={() => setOpenCreateUseCaseDialog(true)}
                sx={{
                  mt: 2,
                  borderRadius: "10px",
                  textTransform: "none",
                  fontWeight: 600,
                  height: 40,
                  px: 3,
                  background: !currentFolderData
                    ? theme.palette.action.disabledBackground
                    : "linear-gradient(90deg, hsl(var(--cyan)), hsl(var(--emerald)))",
                  color: "hsl(var(--primary-foreground))",
                  boxShadow: "0 4px 14px hsl(var(--cyan) / 0.35)",
                  "&:hover": {
                    background:
                      "linear-gradient(90deg, hsl(var(--cyan) / 0.9), hsl(var(--emerald) / 0.9))",
                    boxShadow: "0 6px 20px hsl(var(--cyan) / 0.45)",
                  },
                  "&:active": {
                    transform: "scale(0.98)",
                  },
                }}
              >
                Create New Use Case
              </Button>
            </Box>
          </Box>
        ) : (
          <Box className={`flex w-full`}>
            {isGridViewEnabled ? (
              <Suspense fallback={<FallbackUILoader />}>
                <UseCaseGrid
                  dataList={finalList}
                  isLoading={isActiveProjectContainerLoading}
                />
              </Suspense>
            ) : (
              <Suspense fallback={<FallbackUILoader />}>
                <UseCaseList
                  dataList={finalList}
                  isLoading={isActiveProjectContainerLoading}
                />
              </Suspense>
            )}
          </Box>
        )}
      </Box>
      <Suspense fallback={<FallbackUILoader />}>
        {openItemFilterDrawer && (
          <FilterItemDrawer
            open={openItemFilterDrawer}
            onClose={() => {
              console.log("Closing filter drawer from main component");
              setOpenItemFilterDrawer(false);
            }}
          />
        )}
      </Suspense>

      {/* ADD THE MOVECOPY DIALOG HERE - AT THE VERY END */}
      <Suspense fallback={<FallbackUILoader />}>
        {openActionDialog && (
          <MoveCopyDialog
            open={openActionDialog}
            onClose={handleActionDialogClose}
            items={selectedItemsForAction}
            currentFolderPath={currentFolderData?.path || ""}
            projectName={activeProject?.name}
            section="useCase"
            operation={actionDialogType}
          />
        )}
      </Suspense>
    </Box> // This is the closing Box of the component
  );
}

function TestCaseContainerComponent() {
  const {
    isGridViewEnabled,
    setIsGridViewEnabled,
    handleSnackbar,
    currentFolderData,
    setCurrentFolderData,
    currentUseCaseData,
    setCurrentUseCaseData,
    filteredTestCaseList,
    setFilteredTestCaseList,
    isActiveProjectContainerLoading,
    setIsActiveProjectContainerLoading,
    selectedTestCaseList,
    setSelectedTestCaseList,
    openDeleteStoryDialog,
    setOpenDeleteUseCaseDialog,
    currentFilters,
    setCurrentFilters,
    openItemFilterDrawer,
    setOpenItemFilterDrawer,
    useCasePropertiesData,
    setUseCasePropertiesData,
    activeProject,
    testCaseList,
    setTestCaseList,
  } = useApplicationContext();

  const {
    labelList,
    setLabelList,
    selectedLabels,
    setSelectedLabels,
    labelAnchorEl,
    setLabelAnchorEl,
    searchText,
    setSearchText,
    loading,
    setLoading,
    openLabelDialog,
    setOpenLabelDialog,
    isLabelEditMode,
    setIsLabelEditMode,
    currentLabelData,
    setCurrentLabelData,
    labelData,
    setLabelData,
    handleToggleLabelPopup,
    handleChangeLabel,
    handleOpenLabelAddUpdate_Dialog,
    handleLabelUpdate,
    handleAddLabel,
    handleCloseDialog,
    handleClickLabelButton,
    handleGetList,
    setOpenCreateUseCaseDialog
  } = useApplicationContext();

  const theme = useTheme();
  const errorHandler = useErrorHandler();
  const pathName = useLocation().pathname;
  const { t } = useTranslation("translation", { keyPrefix: "activeProject" });

  const isTabletScreen = useMediaQuery((theme) => theme.breakpoints.down("xl"));

  const [isLoading, setIsLoading] = useState(false);
  const [isShowFilters, setIsShowFilters] = useState(true);
  const [actionType, setActionType] = useState("label");
  const [actionIconAnchorEl, setActionIconAnchorEl] = useState(null);

  const [finalList, setFinalList] = useState(filteredTestCaseList || []);
  const [selectedPropertiesData, setSelectedPropertiesData] = useState(null);

  const [priorityList, setPriorityList] = useState([]);
  const [typeList, setTypeList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [statusList, setStatusList] = useState([]);

  // ADD THESE STATE VARIABLES HERE
  const [openActionDialog, setOpenActionDialog] = useState(false);
  const [actionDialogType, setActionDialogType] = useState(null); // 'copy' or 'move'
  const [selectedItemsForAction, setSelectedItemsForAction] = useState([]);

  const MoveCopyDialog = lazy(() => import("../../dialog/MoveCopyDialog"));

  const [activeFilterData, setActiveFilterData] = useState({
    status: "all",
  });

  // Debug log
  // console.log("TestCaseContainerComponent - testCaseList:", testCaseList);
  // console.log("TestCaseContainerComponent - filteredTestCaseList:", filteredTestCaseList);
  // console.log("TestCaseContainerComponent - finalList:", finalList);

  // Check if there's no data available - FIXED: Use testCaseList
  const hasNoData = !testCaseList || testCaseList?.length === 0;
  const showDisabledOverlay = hasNoData;

  const handleChangeSearch = debounce((value) => {
    setSearchText(value);
  }, 300);

  const handleDeleteClick = () => {
    setOpenDeleteUseCaseDialog(true);
    console.log(openDeleteStoryDialog, "true");
  };

  const handleChangeFilter = (e) => {
    setActiveFilterData({
      ...activeFilterData,
      [e.target.name]: e.target.value,
    });
  };

  const handleToggleActionMenu = (event, actionType) => {
    if (!actionIconAnchorEl) {
      setActionIconAnchorEl(event.currentTarget);
      setActionType(actionType);
    } else {
      setActionIconAnchorEl(null);
    }
  };

  const handleRemoveFilterItem = (key, value) => {
    let filter = currentFilters ? { ...currentFilters } : {};

    if (Array.isArray(filter[key])) {
      filter[key] = currentFilters[key].filter((item) => item !== value);
      if (filter[key].length === 0) {
        delete filter[key];
      }
    } else {
      if (key === "from") {
        delete filter["createdAt"][key];
      }

      if (key === "to") {
        delete filter["createdAt"][key];
      }

      if (
        filter["createdAt"] &&
        Object.keys(filter["createdAt"])?.length === 0
      ) {
        delete filter["createdAt"];
      } else {
        delete filter[key];
      }
    }

    if (filter && Object.keys(filter)?.length === 0) {
      setCurrentFilters(null);
      return;
    }

    setCurrentFilters(filter);
  };

  const handleGetFilterCount = (value) => {
    if (value === Filters.status) {
      return currentFilters?.status?.length;
    }

    if (value === Filters.createdAt) {
      return currentFilters?.createdAt?.from && currentFilters?.createdAt?.to
        ? 2
        : currentFilters?.createdAt?.from
          ? 1
          : currentFilters?.createdAt?.to
            ? 1
            : 0;
    }
  };

  const handleChangeColumnFilter = (event, key) => {
    const filterData = currentFilters ? { ...currentFilters } : {};

    if (event.target.value === "") {
      delete filterData[key];
    } else {
      filterData[key] = event.target.value;
    }

    setCurrentFilters(filterData);
  };

  const handleSelectProperites = (key, value) => {
    setSelectedPropertiesData({ ...selectedPropertiesData, [key]: value });
  };

  const handleCancelPropertiesData = () => {
    setSelectedPropertiesData(null);
    setActionIconAnchorEl(null);
  };

  const handleApplyPropertiesData = () => {
    let body = {
      customIds: [selectedTestCaseList?.map((item) => item?.customId)],
      folderPath: currentFolderData?.path,
      projectName: activeProject?.name,
    };

    body = { ...body, ...selectedPropertiesData };

    handleUpdateTestCase(body);
  };

  const handleUpdateTestCase = async (testCaseData) => {
    try {
      setIsActiveProjectContainerLoading(true);

      let body = {
        ...testCaseData,
      };

      const bodyFormData = new FormData();
      Object.keys(body).forEach((key) => {
        if (Array.isArray(body[key])) {
          bodyFormData.append(key, body[key]);
        } else {
          bodyFormData.append(key, body[key]);
        }
      });

      const response = await updateTestCase_API(bodyFormData);
      console.log(response, "response handleUpdateTestCase");

      if (response) {
        errorHandler(response, setIsActiveProjectContainerLoading);
      }

      if (response?.status === HttpStatusCode.Ok) {
        let updatedList = response.data;

        updatedList?.forEach((item) => {
          let list = testCaseList;
          let foundIndex = list?.findIndex(
            (listItem) => listItem?.customId === item?.customId,
          );
          if (foundIndex !== -1) {
            list[foundIndex] = item;
          }
          setTestCaseList(
            list?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)),
          );
        });

        setSelectedTestCaseList([]);
        setActionIconAnchorEl(null);

        setTimeout(() => {
          handleSnackbar("TestCase updated successfully", Severity.success);
        }, 500);
      }

      console.log(response, "projectreponse data");
    } catch (error) {
      console.log(error, error?.message, "projectreponse errorr");
      handleSnackbar(String(error), Severity.error);
    } finally {
      setTimeout(() => {
        setIsActiveProjectContainerLoading(false);
      }, 1000);
    }
  };

  useEffect(() => {
    let list = filteredTestCaseList || testCaseList || [];

    if (searchText) {
      list = list?.filter(
        (item) =>
          item?.customId?.toLowerCase()?.includes(searchText.toLowerCase()) ||
          item?.title?.toLowerCase()?.includes(searchText.toLowerCase()) ||
          item?.state?.toLowerCase()?.includes(searchText.toLowerCase()) ||
          item?.status?.toLowerCase()?.includes(searchText.toLowerCase()) ||
          item?.priority?.toLowerCase()?.includes(searchText.toLowerCase()) ||
          item?.type?.toLowerCase()?.includes(searchText.toLowerCase()),
      );
    }

    setFinalList(list);
  }, [searchText, filteredTestCaseList, testCaseList, setFinalList]);

  useEffect(() => {
    setIsLoading(isActiveProjectContainerLoading);
  }, [isActiveProjectContainerLoading, setIsActiveProjectContainerLoading]);

  useEffect(() => {
    setIsLoading(true);
    if (currentFilters) {
      const filteredRows = testCaseList?.filter((row) =>
        Object.entries(currentFilters).every(([column, value]) => {
          console.log(column, value, row, "column, value, row");
          if (!value) return true;
          if (Array.isArray(value)) {
            return value.includes(row[column]?.toString());
          } else {
            if (column === "createdAt") {
              if (value.from && value.to) {
                return (
                  dayjs(row["createdAt"]).isAfter(dayjs(value.from), "day") &&
                  dayjs(row["createdAt"]).isBefore(dayjs(value.to), "day")
                );
              } else if (value.from) {
                return (
                  dayjs(row["createdAt"]).isAfter(dayjs(value.from), "day") ||
                  dayjs(row["createdAt"]).isSame(dayjs(value.from), "day")
                );
              } else if (value.to) {
                return (
                  dayjs(row["createdAt"]).isBefore(dayjs(value.to), "day") ||
                  dayjs(row["createdAt"]).isSame(dayjs(value.to), "day")
                );
              } else {
                return false;
              }
            } else {
              return row[column]
                ?.toString()
                .toLowerCase()
                .includes(value.toLowerCase());
            }
          }
        }),
      );
      setFilteredTestCaseList(filteredRows);
      console.log(filteredRows, "filteredRows");
    } else {
      setFilteredTestCaseList(testCaseList);
    }

    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, [currentFilters, testCaseList, setFilteredTestCaseList]);

  useEffect(() => {
    setFilteredTestCaseList(testCaseList);
  }, [testCaseList, setFilteredTestCaseList]);

  useEffect(() => {
    if (useCasePropertiesData) {
      setTypeList(useCasePropertiesData["type"]);
      setStateList(useCasePropertiesData["state"]);
      setStatusList(useCasePropertiesData["status"]);
      setPriorityList(useCasePropertiesData["priority"]);
    }
  }, [useCasePropertiesData]);

  console.log(isTabletScreen, "isTabletScreen");

  const handleApplyTestCaseLabels = async (labels) => {
    if (!selectedTestCaseList || selectedTestCaseList.length === 0) return;

    try {
      setLoading(true);

      for (const testCase of selectedTestCaseList) {
        const payload = {
          customIds: [testCase?.customId],
          lastModifiedAt: testCase?.lastModifiedAt,
          folderPath: testCase?.folderPath,
          projectName: activeProject?.name,
          labels: labels.map((l) => l.name).join(","),
        };

        const formData = new FormData();
        Object.keys(payload).forEach((key) => {
          if (Array.isArray(payload[key])) {
            formData.append(key, payload[key].join(","));
          } else {
            formData.append(key, payload[key]);
          }
        });

        await updateTestCase_API(formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        const index = testCaseList.findIndex(
          (item) => item.customId === testCase.customId,
        );
        if (index !== -1) {
          const updatedTestCase = {
            ...testCase,
            labels: labels.map((l) => ({
              name: l.name,
              colorCode: l.colorCode,
            })),
          };
          const newList = [...testCaseList];
          newList[index] = updatedTestCase;
          setTestCaseList(newList);
        }
      }

      handleSnackbar("Labels updated successfully", Severity.success);
      setLabelAnchorEl(null);
    } catch (err) {
      console.error(err);
      handleSnackbar(err.message, Severity.error);
    } finally {
      setLoading(false);
    }
  };

  const handleMoveAction = () => {
    const items = selectedTestCaseList;
    if (!items || items.length === 0) {
      handleSnackbar("Please select items to move", "warning");
      return;
    }
    setSelectedItemsForAction(items);
    setActionDialogType("move");
    setOpenActionDialog(true);
  };

  const handleCopyAction = () => {
    const items = selectedTestCaseList;
    if (!items || items.length === 0) {
      handleSnackbar("Please select items to copy", "warning");
      return;
    }
    setSelectedItemsForAction(items);
    setActionDialogType("copy");
    setOpenActionDialog(true);
  };

  const handleActionDialogClose = (success) => {
    setOpenActionDialog(false);
    setSelectedItemsForAction([]);
    setActionDialogType(null);

    if (success) {
      setSelectedTestCaseList([]);
      if (pathName === ModulePath.testCase) {
        // Refresh logic here
      }
    }
  };

  const [testCaseFolderList, setTestCaseFolderList] = useState([]);

  const handleTestCaseDelete = async (selectedTestCases) => {
    if (!selectedTestCases || selectedTestCases.length === 0) return;

    const validTestCases = selectedTestCases.filter((tc) =>
      testCaseList.some((item) => item.customId === tc.customId),
    );

    if (validTestCases.length === 0) {
      handleSnackbar("Selected test cases are already deleted", "error");
      return;
    }

    const folderMap = {};
    validTestCases.forEach((tc) => {
      if (!folderMap[tc.folderPath]) folderMap[tc.folderPath] = [];
      folderMap[tc.folderPath].push(tc.customId);
    });

    try {
      setLoading(true);

      for (const folderPath in folderMap) {
        const body = {
          customIds: folderMap[folderPath],
          folderPath,
          projectName: activeProject?.name,
        };

        const response = await deleteTestCase_API(body);

        if (response.status === HttpStatusCode.Ok) {
          setTestCaseList((prev) =>
            prev.filter(
              (item) => !folderMap[folderPath].includes(item.customId),
            ),
          );

          setTestCaseFolderList((prev) =>
            prev.map((f) =>
              f.name === folderPath
                ? { ...f, count: f.count - folderMap[folderPath].length }
                : f,
            ),
          );

          handleSnackbar(response?.data?.message, "success");
        } else {
          errorHandler(response);
        }
      }
    } catch (error) {
      console.error(error, "test case delete error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className="flex flex-col gap-4 w-full h-full overflow-hidden relative">
      {/* {showDisabledOverlay && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
           
            backdropFilter: "blur(2px)",
            zIndex: 10,
            pointerEvents: "none",
            borderRadius: theme.shape.borderRadius,
          }}
        />
      )} */}

      <Box
        className="flex flex-col gap-4"
        sx={{ position: "relative", zIndex: 11 }}
      >
        <Box
          className={`flex items-center justify-between gap-2 h-fit w-full overflow-hidden`}
        >
          <Box className="flex items-center gap-2 w-fit h-fit">
            <TextField
              type="search"
              variant="outlined"
              placeholder={t("header.searchText")}
              disabled={hasNoData}
              className=""
              sx={{
                minWidth: "100px",
                opacity: hasNoData ? 0.6 : 1,
              }}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="center">
                      <Search sx={{ opacity: hasNoData ? 0.6 : 1 }} />
                    </InputAdornment>
                  ),
                },
              }}
              defaultValue={searchText}
              onChange={(e) => handleChangeSearch(e.target.value)}
            />

            <Box className="flex items-center ">
              <Button
                variant="outlined"
                startIcon={
                  <FilterAltOutlined sx={{ opacity: hasNoData ? 0.6 : 1 }} />
                }
                onClick={() => setOpenItemFilterDrawer(true)}
                disabled={hasNoData}
                sx={{
                  opacity: hasNoData ? 0.6 : 1,
                  "&.Mui-disabled": {
                    opacity: 0.6,
                  },
                }}
              >
                <Typography
                  className="inline-flex"
                  sx={{ opacity: hasNoData ? 0.6 : 1 }}
                >
                  Filter{" "}
                  {currentFilters && Object.keys(currentFilters).length > 0 && (
                    <Typography>{` [${
                      currentFilters && Object.keys(currentFilters).length
                    }]`}</Typography>
                  )}
                </Typography>
              </Button>
            </Box>
          </Box>

          <Box className="  flex-1 flex items-center justify-end gap-2 overflow-hidden  ">
            <Box className="flex items-center justify-end gap-2  overflow-x-auto ">
              <LightTooltip title={t("header.labelText") || "Label"}>
                <span>
                  <IconButton
                    disabled={hasNoData || selectedTestCaseList?.length === 0}
                    onClick={(e) => setLabelAnchorEl(e.currentTarget)}
                  >
                    <LabelButton
                      selectedList={selectedLabels}
                      anchorEl={labelAnchorEl}
                      open={Boolean(labelAnchorEl)}
                      handleApply={handleApplyTestCaseLabels}
                      disabled={hasNoData || selectedTestCaseList?.length === 0}
                      handleClose={() => setLabelAnchorEl(null)}
                    />
                  </IconButton>
                </span>
              </LightTooltip>

              <LightTooltip title={t("header.propertiesText") || "Properties"}>
                <span>
                  <IconButton
                    disabled={hasNoData || selectedTestCaseList?.length === 0}
                    onClick={(e) => handleToggleActionMenu(e, "properties")}
                    sx={{ opacity: hasNoData ? 0.6 : 1 }}
                  >
                    <SettingsOutlined />
                  </IconButton>
                </span>
              </LightTooltip>

              <LightTooltip title={t("header.copyText") || "Copy"}>
                <span>
                  <IconButton
                    disabled={
                      hasNoData ||
                      !selectedTestCaseList ||
                      selectedTestCaseList.length === 0
                    }
                    onClick={handleCopyAction}
                    sx={{ opacity: hasNoData ? 0.6 : 1 }}
                  >
                    <FileCopyOutlined />
                  </IconButton>
                </span>
              </LightTooltip>

              <LightTooltip title={t("header.moveText") || "Move"}>
                <span>
                  <IconButton
                    disabled={
                      hasNoData ||
                      !selectedTestCaseList ||
                      selectedTestCaseList.length === 0
                    }
                    onClick={handleMoveAction}
                    sx={{ opacity: hasNoData ? 0.6 : 1 }}
                  >
                    <DriveFileMove />
                  </IconButton>
                </span>
              </LightTooltip>

              <LightTooltip title={t("header.deleteText") || "Delete"}>
                <span>
                  <IconButton
                    disabled={hasNoData || selectedTestCaseList?.length === 0}
                    onClick={() => handleTestCaseDelete(selectedTestCaseList)}
                    sx={{ opacity: hasNoData ? 0.6 : 1 }}
                  >
                    <DeleteOutline />
                  </IconButton>
                </span>
              </LightTooltip>

              <LightTooltip title={t("header.uploadText") || "Upload"}>
                <span>
                  <IconButton
                    disabled={
                      hasNoData || true || selectedTestCaseList?.length === 0
                    }
                    onClick={() => {}}
                    sx={{ opacity: hasNoData ? 0.6 : 1 }}
                  >
                    <FileUploadOutlined />
                  </IconButton>
                </span>
              </LightTooltip>

              <LightTooltip title={t("header.downloadText") || "Download"}>
                <span>
                  <IconButton
                    disabled={
                      hasNoData || true || selectedTestCaseList?.length === 0
                    }
                    onClick={() => {}}
                    sx={{ opacity: hasNoData ? 0.6 : 1 }}
                  >
                    <FileDownloadOutlined />
                  </IconButton>
                </span>
              </LightTooltip>
            </Box>

            <Box className=" h-full flex items-center  gap-2  rounded-lg overflow-hidden ">
              <Paper
                elevation={0}
                sx={(theme) => ({
                  display: "flex",
                  border: `1px solid ${theme.palette.divider}`,
                  flexWrap: "wrap",
                  opacity: hasNoData ? 0.6 : 1,
                })}
              >
                <StyledToggleButtonGroup
                  size="small"
                  value={isGridViewEnabled}
                  exclusive
                  disabled={hasNoData}
                  onChange={(e, newValue) => {
                    console.log(
                      newValue,
                      isGridViewEnabled,
                      newValue !== isGridViewEnabled,
                      "value togglebutton",
                    );
                    if (newValue !== null) {
                      setIsGridViewEnabled(newValue);
                    }
                  }}
                  aria-label="text alignment"
                  sx={{
                    boxSizing: "border-box",
                    "&.Mui-disabled": {
                      opacity: 0.6,
                    },
                  }}
                >
                  <StyledToggleButton
                    value={true}
                    aria-label="centered"
                    disabled={hasNoData}
                  >
                    <LightTooltip title={t("header.gridText")}>
                      <GridViewTwoToneIcon />
                    </LightTooltip>
                  </StyledToggleButton>

                  <StyledToggleButton
                    value={false}
                    aria-label="centered"
                    disabled={hasNoData}
                  >
                    <LightTooltip title={t("header.listText")}>
                      <ListTwoToneIcon />
                    </LightTooltip>
                  </StyledToggleButton>
                </StyledToggleButtonGroup>
              </Paper>
            </Box>
          </Box>
        </Box>

        {currentFilters && Object.keys(currentFilters)?.length > 0 && (
          <Box className=" h-fit w-full flex  overflow-x-auto ">
            <Box
              className={` h-fit w-full flex items-center gap-2 overflow-x-auto `}
            >
              {currentFilters &&
                Object.keys(currentFilters)?.map((key, index) => {
                  return (
                    <Box
                      className="flex flex-col items-center px-1 pb-1"
                      bgcolor={theme.palette.background.paper}
                      borderRadius={theme.shape.borderRadius}
                    >
                      <Typography
                        fontSize={font.size.fs_6}
                        className="flex capitalize"
                      >
                        {key}
                      </Typography>
                      <Box className="flex items-center gap-1">
                        {Array.isArray(currentFilters[key])
                          ? currentFilters[key]?.map((itemValue, index) => (
                              <Box
                                key={index}
                                className="flex items-center gap-1 px-1 border"
                                bgcolor={theme.palette.background.custom}
                                borderRadius={theme.shape.borderRadius}
                              >
                                <Typography
                                  fontSize={font.size.fs_6}
                                  lineHeight={font.size.fs_6}
                                >
                                  {itemValue}
                                </Typography>
                                <Close
                                  sx={{
                                    fontSize: font.size.fs_5,
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handleRemoveFilterItem(key, itemValue)
                                  }
                                />
                              </Box>
                            ))
                          : Object.keys(currentFilters[key])?.map(
                              (ObjectKey, index) => {
                                console.log(
                                  dayjs(currentFilters[key][ObjectKey]).format(
                                    "DD-MM-YYYY",
                                  ),
                                  "currentFilters[key][ObjectKey]",
                                );
                                return (
                                  <Box
                                    key={index}
                                    className="flex items-center gap-1 px-1 border"
                                    bgcolor={theme.palette.background.custom}
                                    borderRadius={theme.shape.borderRadius}
                                  >
                                    <Typography
                                      fontSize={font.size.fs_6}
                                      lineHeight={font.size.fs_6}
                                      className="whitespace-nowrap"
                                    >
                                      {dayjs(
                                        currentFilters[key][ObjectKey],
                                      ).format("DD-MM-YYYY")}
                                    </Typography>
                                    <Close
                                      sx={{
                                        fontSize: font.size.fs_5,
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        handleRemoveFilterItem(
                                          ObjectKey,
                                          currentFilters[key][ObjectKey],
                                        )
                                      }
                                    />
                                  </Box>
                                );
                              },
                            )}
                      </Box>
                    </Box>
                  );
                })}
            </Box>
          </Box>
        )}

        <Popover
          open={Boolean(actionIconAnchorEl)}
          anchorEl={actionIconAnchorEl}
          onClose={(e) => handleToggleActionMenu(e, null)}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <Box>
            {actionType === "label" &&
              ["red", "blue", "green", "grey", "brown"].map((item, index) => {
                return (
                  <MenuItem>
                    <LabelOutlined sx={{ color: item }} />
                  </MenuItem>
                );
              })}

            <Box className="flex items-center px-4 py-2 border-b">
              <Typography
                color={theme.palette.text.primary}
                fontSize={font.size.fs_4}
              >
                Properties
              </Typography>
            </Box>

            {actionType === "properties" && (
              <Box className="flex gap-0 divide-x">
                {useCasePropertiesData &&
                  Object.keys(useCasePropertiesData).map((key) => (
                    <Box key={key} className="flex flex-col">
                      <Typography
                        fontSize={font.size.fs_5}
                        color={theme.palette.text.primary}
                        className="px-4 py-1 capitalize border-b"
                      >
                        {key}
                      </Typography>
                      <Box className="w-full h-full flex flex-col ">
                        {useCasePropertiesData[key]?.map((item, index) => (
                          <MenuItem
                            key={index}
                            selected={
                              selectedPropertiesData &&
                              key in selectedPropertiesData &&
                              selectedPropertiesData[key] &&
                              selectedPropertiesData[key] === item?.key
                            }
                            onClick={() => {
                              handleSelectProperites(key, item?.key);
                            }}
                          >
                            <Typography
                              fontSize={font.size.fs_5}
                              color={theme.palette.text.secondary}
                              className=""
                            >
                              {item?.value}
                            </Typography>
                          </MenuItem>
                        ))}
                      </Box>
                    </Box>
                  ))}
              </Box>
            )}

            <Box className="flex items-center justify-end px-4 py-2 border-t">
              <Button
                variant="text"
                onClick={(e) => handleCancelPropertiesData()}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="secondary"
                sx={{ color: theme.palette.secondary.contrastText }}
                onClick={handleApplyPropertiesData}
              >
                Apply
              </Button>
            </Box>
          </Box>
        </Popover>
      </Box>

      {/* list container - FIXED: Show TestCaseList component */}
      <Box
        className={`flex w-full  ${
          isGridViewEnabled ? "h-full" : "h-full"
        } overflow-y-auto `}
        sx={{ position: "relative", zIndex: 11 }}
      >
        {isLoading || isActiveProjectContainerLoading ? (
          <Box
            className={`grow flex flex-col gap-2 items-center justify-center `}
            border={`1px solid ${theme.palette.divider}`}
            bgcolor={theme.palette.background.paper}
            borderRadius={theme.shape.borderRadius}
          >
            <Typography fontSize={font.size.fs_5}>Loading...</Typography>
          </Box>
        ) : finalList?.length === 0 ? (
          <Box
            className="grow flex flex-col gap-2 justify-center items-center "
            border={`1px solid ${theme.palette.divider}`}
            bgcolor={theme.palette.background.paper}
            borderRadius={theme.shape.borderRadius}
          >
            {/* <TestCaseCustomIcon
              sx={{ fontSize: font.size.fs_2, opacity: 0.6 }}
            />
            <Typography fontSize={font.size.fs_5} color="textSecondary">
              {t("addText")} {Entity_Label.testCase}
            </Typography> */}
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              minHeight={400}
              gap={2}
              sx={{ mt: 4 }}
            >
              <UserStoryCustomIcon
                sx={{
                  fontSize: 80,
                  color: (theme) => theme.palette.text.secondary,
                  opacity: 0.7,
                }}
              />
              <Typography variant="h5" color="text.secondary" fontWeight={500}>
                No test case found
              </Typography>
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ opacity: 0.8 }}
              >
                Create your first test case to get started
              </Typography>
              <Button
                startIcon={<Add />}
                disabled={!currentFolderData}
                onClick={() => setOpenCreateUseCaseDialog(true)}
                sx={{
                  mt: 2,
                  borderRadius: "10px",
                  textTransform: "none",
                  fontWeight: 600,
                  height: 40,
                  px: 3,
                  background: !currentFolderData
                    ? theme.palette.action.disabledBackground
                    : "linear-gradient(90deg, hsl(var(--cyan)), hsl(var(--emerald)))",
                  color: "hsl(var(--primary-foreground))",
                  boxShadow: "0 4px 14px hsl(var(--cyan) / 0.35)",
                  "&:hover": {
                    background:
                      "linear-gradient(90deg, hsl(var(--cyan) / 0.9), hsl(var(--emerald) / 0.9))",
                    boxShadow: "0 6px 20px hsl(var(--cyan) / 0.45)",
                  },
                  "&:active": {
                    transform: "scale(0.98)",
                  },
                }}
              >
                Create New Test Case
              </Button>
            </Box>
          </Box>
        ) : (
          <Box className={`flex w-full`}>
            {isGridViewEnabled ? (
              <Suspense fallback={<FallbackUILoader />}>
                {/* You might want to create a TestCaseGrid component */}
                <UseCaseGrid
                  dataList={finalList}
                  isLoading={isActiveProjectContainerLoading}
                />
              </Suspense>
            ) : (
              <Suspense fallback={<FallbackUILoader />}>
                <TestCaseList dataList={finalList} />
              </Suspense>
            )}
          </Box>
        )}
      </Box>
      <Suspense fallback={<FallbackUILoader />}>
        {openItemFilterDrawer && (
          <FilterItemDrawer
            open={openItemFilterDrawer}
            onClose={() => {
              console.log("Closing filter drawer from main component");
              setOpenItemFilterDrawer(false);
            }}
          />
        )}
      </Suspense>

      {/* ADD THE MOVECOPY DIALOG HERE - AT THE VERY END */}
      <Suspense fallback={<FallbackUILoader />}>
        {openActionDialog && (
          <MoveCopyDialog
            open={openActionDialog}
            onClose={handleActionDialogClose}
            items={selectedItemsForAction}
            currentFolderPath={currentFolderData?.path || ""}
            projectName={activeProject?.name}
            section="testCase"
            operation={actionDialogType}
          />
        )}
      </Suspense>
    </Box> // This is the closing Box of the component
  );
}